import {
  subDays,
  subWeeks,
  subYears,
  startOfMonth,
  subMonths,
  endOfMonth,
  startOfQuarter,
  subQuarters,
  startOfYear,
  endOfYear,
  startOfWeek,
  endOfQuarter,
  endOfWeek,
  addDays,
} from 'date-fns';
import { CTR } from '../metrics';

export const METRICS_OPTIONS = [
  { text: 'Clicks', value: 'clicks' },
  { text: 'Impressions', value: 'impressions' },
  { text: 'CTR', value: 'average^_ctr' },
  { text: 'Position', value: 'average^_position' },
  { text: 'Visitors', value: 'visitors' },
  { text: 'Conversions', value: 'conversions' },
  // { text: 'Transaction Revenue', value: 'transaction^_revenue' },
  { text: 'Unique Pages', value: 'pages' },
  { text: 'Unique Keywords', value: 'keywords' },
  {
    text: 'Site Speed',
    value: 'Site Speed',
    subMenuItems: [
      {
        text: 'Usability Score',
        value: 'Usability Score',
        subMenuItems: [
          { text: 'Performance Score', value: 'performance' },
          { text: 'Accessibility Score', value: 'AccessibilityScore' },
          { text: 'Best Practices Score', value: 'BestPracticesScore' },
          { text: 'SEO Compliance Score', value: 'SEOScore' },
        ],
      },
      {
        text: 'Performance Metrics',
        value: 'Performance Metrics',
        subMenuItems: [
          { text: 'Speed Index', value: 'SIScore' },
          { text: 'First Contentful Paint (FCP)', value: 'FCPScore' },
          { text: 'Cumulative Layout Shift (CLS)', value: 'CLSScore' },
          { text: 'Time to Interactive (TTI)', value: 'TTIScore' },
          { text: 'Total Blocking Time (TBT)', value: 'TBTScore' },
          { text: 'Largest Contentful Paint (LCP)', value: 'LCPScore' },
          { text: 'Interaction to Next Paint (INP)', value: 'INPScore' },
        ],
      },
    ],
  },
  { text: 'Sessions', value: 'TOTAL_SESSIONS' },
  {
    text: 'Conversions & Value',
    value: 'Conversions & Value',
    subMenuItems: [
      { text: 'Conversion Rate', value: 'conversion^_rate' },
      { text: 'Transactions', value: 'transaction' },
      { text: 'Total Value', value: 'total^_value' },
    ],
  },
  {
    text: 'Engagement',
    value: 'Engagement',
    subMenuItems: [
      { text: 'Bounce Rate', value: 'bounce^_rate' },
      { text: 'Average Session Duration', value: 'average^_session^_duration' },
      { text: 'Unique Pageviews', value: 'unique^_page^_views' },
      { text: 'Average Time on Page', value: 'average^_time^_on^_pagee' },
      { text: 'Total Events', value: 'total^_events' },
      { text: 'Average Events', value: 'average^_events' },
    ],
  },
  {
    text: 'Google Ads',
    value: 'Google Ads',
    subMenuItems: [
      { text: 'Total Cost', value: 'cost' },
      { text: 'Cost Per Clicks', value: 'avg^_cpc' },
      { text: 'Cost Per Conversions', value: 'cost^_per^_conversion' },
      { text: 'Conversion (Google Ads)', value: 'conversions' },
      { text: 'Conversion Rate (Google Ads)', value: 'conversion^_rate' },
      {
        text: 'Impression Share',
        value: 'Impression Share',
        subMenuItems: [
          { text: 'Avg Search Impression Share', value: 'avg_search_impression_share' },
          { text: 'Avg Search Top Impression Share', value: 'avg_search_top_impression_share' },
          { text: 'Avg Search Absolute Top Impression Share', value: 'avg_search_absolute_top_impression_share' },
          { text: 'Avg Search Rank Lost Impression Share', value: 'avg_search_rank_lost_impression_share' },
          { text: 'Avg Search Rank Lost Top Impression Share', value: 'avg_search_rank_lost_top_impression_share' },
          {
            text: 'Avg Search Rank Lost Absolute Top Impression Share',
            value: 'avg_search_rank_lost_absolute_top_impression_share',
          },
        ],
      },
    ],
  },
  // { // removed temporarily as part of https://quattr.atlassian.net/browse/PPP-43
  //   text: "Indexation",
  //   value: "Indexation",
  //   subMenuItems: [
  //     { text: "Total Pages Indexed", value: "total_pages_indexed_M" },
  //     { text: "% Pages Indexed", value: "percent_pages_indexed_M" },
  //   ],
  // }
];

export const GA_ALL_CONVERSIONS = [
  'goal1',
  'goal2',
  'goal3',
  'goal4',
  'goal5',
  'goal6',
  'goal7',
  'goal8',
  'goal9',
  'goal10',
];

export const GA_ALL_TRAFFIC_SOURCE = [
  'conversions',
  'conversion rate',
  'total value',
  'conversion summary',
  'transactions',
  // 'transaction revenue',
];
export const RANKING_FACTORS_METRICS_OPTIONS = [
  { text: 'Top Ranking Factors', value: 'RANKING_FACTOR_AGG' },
  { text: 'Content Quality Score', value: 'CONTENT_QUALITY_SCORE_M' },
  { text: 'Keyword Relevance Score', value: 'KEYWORD_EMPHASIS_SCORE_M' },
  { text: 'Performance Score', value: 'WAVG_PERF_SCORE_M' },
  { text: 'Accessibility Score', value: 'WAVG_ACCESSIBILITY_SCORE_M' },
  { text: 'Best Practices', value: 'WAVG_BEST_PRACTICES_SCORE_M' },
  { text: 'SEO Compliance Score', value: 'WAVG_SEO_SCORE_M' },
];

export const ADVANCED_FILTER_OPTIONS = [
  { text: 'Is Equal to', value: '{value}' },
  { text: 'Contains', value: '%{value}%' },
  { text: 'Starts With', value: '{value}%' },
  { text: 'Ends With', value: '%{value}' },
  { text: 'Is Blank', value: 'EMPTY' },
  { text: 'Is Null', value: 'NULL' },
  { text: 'Is Not Equal to', value: '-{value}' },
  { text: "Doesn't Contain", value: '-%{value}%' },
  { text: "Doesn't Start with", value: '-{value}%' },
  { text: 'Is not blank', value: '-EMPTY' },
  { text: 'Is not Null', value: '-NULL' },
];

export const ADVANCED_FILTER_OPTIONS_WITH_INCLUDE_EXCLUDE = [
  { text: 'Include', value: '%{value}%' },
  { text: 'Exclude', value: '-%{value}%' },
];

export const ADVANCED_FILTER_OPTIONS_CAMPAIGN_TYPE = [
  { text: 'Is Equal to', value: '{value}' },
  { text: 'Contains', value: '%{value}%' },
  { text: 'Starts With', value: '{value}%' },
  { text: 'Ends With', value: '%{value}' },
  { text: 'Is Not Equal to', value: '-{value}' },
  { text: "Doesn't Contain", value: '-%{value}%' },
  { text: "Doesn't Start with", value: '-{value}%' },
];

export const ADVANCED_FILTER_OPTIONS_INTERNAL_LINKING = [
  { text: 'Is Equal to', value: '{value}' },
  { text: 'Contains', value: '%{value}%' },
  { text: 'Starts With', value: '{value}%' },
  { text: 'Ends With', value: '%{value}' },
  { text: 'Is Not Equal to', value: '-{value}' },
  { text: "Doesn't Contain", value: '-%{value}%' },
  { text: "Doesn't Start with", value: '-{value}%' },
];

export const REGEX_FILTER_CAPABLE_KEYS = ['keyword_segment', 'page_segment'];

export const REGEX_FILTER_OPTIONS = [
  { text: 'Matches Regex', value: 'REGEX:{value}' },
  { text: "Doesn't Match Regex", value: 'NOT_REGEX:{value}' },
];

export const ADVANCED_FILTER_OPTIONS_INTERNAL_LINKING_PAGE_TAGS = [
  { text: 'City', value: 'Page_City', groupName: 'Geography Tags' },
  { text: 'State', value: 'Page_State', groupName: 'Geography Tags' },
  { text: 'Country', value: 'Page_Country', groupName: 'Geography Tags' },
  // { text: 'Canonical Url Tag', value: 'Page_Tag_Canonical_Url_Tag', groupName: 'On-Page SEO Attributes' },
  // { text: 'Parameterized', value: 'Page_Tag_Parameterized', groupName: 'URL Attributes' },
  // { text: 'Language Code', value: 'Page_Tag_Language_Code', groupName: 'Geography Tags' },
  // { text: 'Paginated', value: 'Page_Tag_Paginated', groupName: 'Temporal Attributes' },
  // { text: 'Last Modified', value: 'Page_Tag_Last_Modified', groupName: 'Temporal Attributes' },
  // { text: 'Mime Type', value: 'Page_Tag_Mime_Type', groupName: 'Content Attributes' },
  // { text: 'Author', value: 'Page_Tag_Author', groupName: 'Content Attributes' },
  { text: 'Hreflang', value: 'Page_Tag_Hreflang_Tag', groupName: 'Content Attributes' },
  { text: 'Custom Tag', value: 'Page_Tag_Custom_Tag', groupName: 'Content Attributes' },
];

export const LOAD_STATIC_DATA_FOR_SCHEMAS = [];

export const STATIC_IL_PAGE_TAG_GROUP_DATA = [
  {
    groupName: 'Geography Tags',
    label: 'Geography Tags',
    children: [
      {
        text: 'Country',
        tagKeyName: 'Page_Country',
        value: 'Page_Country',
      },
      {
        text: 'State',
        tagKeyName: 'Page_State',
        value: 'Page_State',
      },
      {
        text: 'City',
        tagKeyName: 'Page_City',
        value: 'Page_City',
      },
      {
        text: 'Continent',
        tagKeyName: 'Page_Continent',
        value: 'Page_Continent',
        disabled: true,
      },
      {
        text: 'Language Locale',
        tagKeyName: 'Page_Language_Locale',
        value: 'Page_Language_Locale',
        disabled: true,
      },
    ],
  },
  {
    groupName: 'URL Attributes',
    label: 'URL Attributes',
    children: [
      {
        text: 'Domain',
        tagKeyName: 'Page_Domain',
        value: 'Page_Domain',
        disabled: true,
      },
      {
        text: 'Subdomain',
        tagKeyName: 'Page_Subdomain',
        value: 'Page_Subdomain',
        disabled: true,
      },
      {
        text: 'Path Depth',
        tagKeyName: 'Page_Path_Depth',
        value: 'Page_Path_Depth',
        disabled: true,
      },
      {
        text: 'URL Structure',
        tagKeyName: 'Page_URL_Structure',
        value: 'Page_URL_Structure',
        disabled: true,
      },
      {
        text: 'URL Keywords',
        tagKeyName: 'Page_URL_Keywords',
        value: 'Page_URL_Keywords',
        disabled: true,
      },
      {
        text: 'Parameterization',
        tagKeyName: 'Page_Parameterization',
        value: 'Page_Parameterization',
        disabled: true,
      },
      {
        text: 'Secure Protocol',
        tagKeyName: 'Page_Secure_Protocol',
        value: 'Page_Secure_Protocol',
        disabled: true,
      },
    ],
  },
  {
    groupName: 'Product Information',
    label: 'Product Information',
    children: [
      {
        text: 'Product Name',
        tagKeyName: 'Page_Product_Name',
        value: 'Page_Product_Name',
        disabled: true,
      },
      {
        text: 'Product ID',
        tagKeyName: 'Page_Product_ID',
        value: 'Page_Product_ID',
        disabled: true,
      },
      {
        text: 'Product Category',
        tagKeyName: 'Page_Product_Category',
        value: 'Page_Product_Category',
        disabled: true,
      },
      {
        text: 'Product Subcategory',
        tagKeyName: 'Page_Product_Subcategory',
        value: 'Page_Product_Subcategory',
        disabled: true,
      },
      {
        text: 'Product Type',
        tagKeyName: 'Page_Product_Type',
        value: 'Page_Product_Type',
        disabled: true,
      },
      {
        text: 'Brand',
        tagKeyName: 'Page_Brand',
        value: 'Page_Brand',
        disabled: true,
      },
      {
        text: 'Price',
        tagKeyName: 'Page_Price',
        value: 'Page_Price',
        disabled: true,
      },
      {
        text: 'Discount Level',
        tagKeyName: 'Page_Discount_Level',
        value: 'Page_Discount_Level',
        disabled: true,
      },
      {
        text: 'Availability',
        tagKeyName: 'Page_Availability',
        value: 'Page_Availability',
        disabled: true,
      },
      {
        text: 'Customer Rating',
        tagKeyName: 'Page_Customer_Rating',
        value: 'Page_Customer_Rating',
        disabled: true,
      },
      {
        text: 'Review Count',
        tagKeyName: 'Page_Review_Count',
        value: 'Page_Review_Count',
        disabled: true,
      },
      {
        text: 'Release Date',
        tagKeyName: 'Page_Release_Date',
        value: 'Page_Release_Date',
        disabled: true,
      },
      {
        text: 'Product Attributes',
        tagKeyName: 'Page_Product_Attributes',
        value: 'Page_Product_Attributes',
        disabled: true,
      },
      {
        text: 'Energy Efficiency Rating',
        tagKeyName: 'Page_Energy_Efficiency_Rating',
        value: 'Page_Energy_Efficiency_Rating',
        disabled: true,
      },
      {
        text: 'Warranty Period',
        tagKeyName: 'Page_Warranty_Period',
        value: 'Page_Warranty_Period',
        disabled: true,
      },
    ],
  },
  {
    groupName: 'Content Attributes',
    label: 'Content Attributes',
    children: [
      {
        text: 'Content Type',
        tagKeyName: 'Page_Content_Type',
        value: 'Page_Content_Type',
        disabled: true,
      },
      {
        text: 'Publish Date',
        tagKeyName: 'Page_Publish_Date',
        value: 'Page_Publish_Date',
        disabled: true,
      },
      {
        text: 'Update Frequency',
        tagKeyName: 'Page_Update_Frequency',
        value: 'Page_Update_Frequency',
        disabled: true,
      },
      {
        text: 'Author',
        tagKeyName: 'Page_Author',
        value: 'Page_Author',
        disabled: true,
      },
      {
        text: 'Topic/Subject',
        tagKeyName: 'Page_Topic_Subject',
        value: 'Page_Topic_Subject',
        disabled: true,
      },
      {
        text: 'Reading Level',
        tagKeyName: 'Page_Reading_Level',
        value: 'Page_Reading_Level',
        disabled: true,
      },
      {
        text: 'Word Count',
        tagKeyName: 'Page_Word_Count',
        value: 'Page_Word_Count',
        disabled: true,
      },
      {
        text: 'Multimedia Content',
        tagKeyName: 'Page_Multimedia_Content',
        value: 'Page_Multimedia_Content',
        disabled: true,
      },
      {
        text: 'Language',
        tagKeyName: 'Page_Language',
        value: 'Page_Language',
        disabled: true,
      },
      {
        text: 'Engagement Level',
        tagKeyName: 'Page_Engagement_Level',
        value: 'Page_Engagement_Level',
        disabled: true,
      },
      {
        text: 'Content Format',
        tagKeyName: 'Page_Content_Format',
        value: 'Page_Content_Format',
        disabled: true,
      },
      {
        text: 'Social Proof',
        tagKeyName: 'Page_Social_Proof',
        value: 'Page_Social_Proof',
        disabled: true,
      },
    ],
  },
  {
    groupName: 'On-Page SEO Attributes',
    label: 'On-Page SEO Attributes',
    children: [
      {
        text: 'Meta Title Length',
        tagKeyName: 'Page_Meta_Title_Length',
        value: 'Page_Meta_Title_Length',
        disabled: true,
      },
      {
        text: 'Meta Description Presence',
        tagKeyName: 'Page_Meta_Description_Presence',
        value: 'Page_Meta_Description_Presence',
        disabled: true,
      },
      {
        text: 'Header Tags Usage',
        tagKeyName: 'Page_Header_Tags_Usage',
        value: 'Page_Header_Tags_Usage',
        disabled: true,
      },
      {
        text: 'Canonical Tag',
        tagKeyName: 'Page_Canonical_Tag',
        value: 'Page_Canonical_Tag',
        disabled: true,
      },
      {
        text: 'Robots Meta Tag',
        tagKeyName: 'Page_Robots_Meta_Tag',
        value: 'Page_Robots_Meta_Tag',
        disabled: true,
      },
      {
        text: 'Page Load Speed',
        tagKeyName: 'Page_Page_Load_Speed',
        value: 'Page_Page_Load_Speed',
        disabled: true,
      },
      {
        text: 'SSL Certificate',
        tagKeyName: 'Page_SSL_Certificate',
        value: 'Page_SSL_Certificate',
        disabled: true,
      },
    ],
  },
  {
    groupName: 'Schema Markup Attributes',
    label: 'Schema Markup Attributes',
    children: [
      {
        text: 'Schema Types',
        tagKeyName: 'Page_Schema_Types',
        value: 'Page_Schema_Types',
        disabled: true,
      },
      {
        text: 'Product Schema Properties',
        tagKeyName: 'Page_Product_Schema_Properties',
        value: 'Page_Product_Schema_Properties',
        disabled: true,
      },
      {
        text: 'Article Schema Properties',
        tagKeyName: 'Page_Article_Schema_Properties',
        value: 'Page_Article_Schema_Properties',
        disabled: true,
      },
      {
        text: 'FAQPage Schema Presence',
        tagKeyName: 'Page_FAQPage_Schema_Presence',
        value: 'Page_FAQPage_Schema_Presence',
        disabled: true,
      },
      {
        text: 'BreadcrumbList Schema Presence',
        tagKeyName: 'Page_BreadcrumbList_Schema_Presence',
        value: 'Page_BreadcrumbList_Schema_Presence',
        disabled: true,
      },
      {
        text: 'Review Schema Properties',
        tagKeyName: 'Page_Review_Schema_Properties',
        value: 'Page_Review_Schema_Properties',
        disabled: true,
      },
      {
        text: 'Event Schema Properties',
        tagKeyName: 'Page_Event_Schema_Properties',
        value: 'Page_Event_Schema_Properties',
        disabled: true,
      },
      {
        text: 'AggregateRating',
        tagKeyName: 'Page_AggregateRating',
        value: 'Page_AggregateRating',
        disabled: true,
      },
      {
        text: 'JobPosting Schema Presence',
        tagKeyName: 'Page_JobPosting_Schema_Presence',
        value: 'Page_JobPosting_Schema_Presence',
        disabled: true,
      },
    ],
  },
  {
    groupName: 'Behavioral Tags',
    label: 'Behavioral Tags',
    children: [
      {
        text: 'Visit Frequency',
        tagKeyName: 'Page_Visit_Frequency',
        value: 'Page_Visit_Frequency',
        disabled: true,
      },
      {
        text: 'Time of Visit',
        tagKeyName: 'Page_Time_Of_Visit',
        value: 'Page_Time_Of_Visit',
        disabled: true,
      },
      {
        text: 'Day of Week',
        tagKeyName: 'Page_Day_Of_Week',
        value: 'Page_Day_Of_Week',
        disabled: true,
      },
      {
        text: 'Device Type',
        tagKeyName: 'Page_Device_Type',
        value: 'Page_Device_Type',
        disabled: true,
      },
      {
        text: 'Browser Type',
        tagKeyName: 'Page_Browser_Type',
        value: 'Page_Browser_Type',
        disabled: true,
      },
      {
        text: 'Traffic Source',
        tagKeyName: 'Page_Traffic_Source',
        value: 'Page_Traffic_Source',
        disabled: true,
      },
      {
        text: 'Engagement Level',
        tagKeyName: 'Page_Behavioral_Engagement_Level',
        value: 'Page_Behavioral_Engagement_Level',
        disabled: true,
      },
      {
        text: 'Conversion Behavior',
        tagKeyName: 'Page_Conversion_Behavior',
        value: 'Page_Conversion_Behavior',
        disabled: true,
      },
      {
        text: 'New vs. Returning Visitor',
        tagKeyName: 'Page_New_Vs_Returning_Visitor',
        value: 'Page_New_Vs_Returning_Visitor',
        disabled: true,
      },
      {
        text: 'Session Duration',
        tagKeyName: 'Page_Session_Duration',
        value: 'Page_Session_Duration',
        disabled: true,
      },
    ],
  },
  {
    groupName: 'LLM-Generated Tags',
    label: 'LLM-Generated Tags',
    children: [
      {
        text: 'Sentiment Analysis',
        tagKeyName: 'Page_Sentiment_Analysis',
        value: 'Page_Sentiment_Analysis',
        disabled: true,
      },
      {
        text: 'Topic Categories',
        tagKeyName: 'Page_Topic_Categories',
        value: 'Page_Topic_Categories',
        disabled: true,
      },
      {
        text: 'Key Entities',
        tagKeyName: 'Page_Key_Entities',
        value: 'Page_Key_Entities',
        disabled: true,
      },
      {
        text: 'Content Summary',
        tagKeyName: 'Page_Content_Summary',
        value: 'Page_Content_Summary',
        disabled: true,
      },
      {
        text: 'Reading Complexity',
        tagKeyName: 'Page_Reading_Complexity',
        value: 'Page_Reading_Complexity',
        disabled: true,
      },
      {
        text: 'Emotional Tone',
        tagKeyName: 'Page_Emotional_Tone',
        value: 'Page_Emotional_Tone',
        disabled: true,
      },
      {
        text: 'User Intent',
        tagKeyName: 'Page_User_Intent',
        value: 'Page_User_Intent',
        disabled: true,
      },
      {
        text: 'FAQs Extracted',
        tagKeyName: 'Page_FAQs_Extracted',
        value: 'Page_FAQs_Extracted',
        disabled: true,
      },
      {
        text: 'Content Gaps',
        tagKeyName: 'Page_Content_Gaps',
        value: 'Page_Content_Gaps',
        disabled: true,
      },
    ],
  },
  {
    groupName: 'Link Attributes',
    label: 'Link Attributes',
    children: [
      {
        text: 'Internal Link Count',
        tagKeyName: 'Page_Internal_Link_Count',
        value: 'Page_Internal_Link_Count',
        disabled: true,
      },
      {
        text: 'External Link Count',
        tagKeyName: 'Page_External_Link_Count',
        value: 'Page_External_Link_Count',
        disabled: true,
      },
      {
        text: 'Backlink Count',
        tagKeyName: 'Page_Backlink_Count',
        value: 'Page_Backlink_Count',
        disabled: true,
      },
      {
        text: 'Link Quality',
        tagKeyName: 'Page_Link_Quality',
        value: 'Page_Link_Quality',
        disabled: true,
      },
      {
        text: 'Anchor Text Diversity',
        tagKeyName: 'Page_Anchor_Text_Diversity',
        value: 'Page_Anchor_Text_Diversity',
        disabled: true,
      },
      {
        text: 'Broken Links',
        tagKeyName: 'Page_Broken_Links',
        value: 'Page_Broken_Links',
        disabled: true,
      },
      {
        text: 'Nofollow Links',
        tagKeyName: 'Page_Nofollow_Links',
        value: 'Page_Nofollow_Links',
        disabled: true,
      },
      {
        text: 'UGC/Sponsored Links',
        tagKeyName: 'Page_UGC_Sponsored_Links',
        value: 'Page_UGC_Sponsored_Links',
        disabled: true,
      },
      {
        text: 'Redirect Links',
        tagKeyName: 'Page_Redirect_Links',
        value: 'Page_Redirect_Links',
        disabled: true,
      },
    ],
  },
  {
    groupName: 'E-commerce Specific Tags',
    label: 'E-commerce Specific Tags',
    children: [
      {
        text: 'Price Range',
        tagKeyName: 'Page_Price_Range',
        value: 'Page_Price_Range',
        disabled: true,
      },
      {
        text: 'Discount Offered',
        tagKeyName: 'Page_Discount_Offered',
        value: 'Page_Discount_Offered',
        disabled: true,
      },
      {
        text: 'Stock Availability',
        tagKeyName: 'Page_Stock_Availability',
        value: 'Page_Stock_Availability',
        disabled: true,
      },
      {
        text: 'Shipping Options',
        tagKeyName: 'Page_Shipping_Options',
        value: 'Page_Shipping_Options',
        disabled: true,
      },
      {
        text: 'Return Policy',
        tagKeyName: 'Page_Return_Policy',
        value: 'Page_Return_Policy',
        disabled: true,
      },
      {
        text: 'Payment Methods',
        tagKeyName: 'Page_Payment_Methods',
        value: 'Page_Payment_Methods',
        disabled: true,
      },
      {
        text: 'Customer Loyalty Program',
        tagKeyName: 'Page_Customer_Loyalty_Program',
        value: 'Page_Customer_Loyalty_Program',
        disabled: true,
      },
      {
        text: 'Product Bundles',
        tagKeyName: 'Page_Product_Bundles',
        value: 'Page_Product_Bundles',
        disabled: true,
      },
      {
        text: 'Subscription Options',
        tagKeyName: 'Page_Subscription_Options',
        value: 'Page_Subscription_Options',
        disabled: true,
      },
      {
        text: 'Gift Options',
        tagKeyName: 'Page_Gift_Options',
        value: 'Page_Gift_Options',
        disabled: true,
      },
    ],
  },
  {
    groupName: 'User Engagement Metrics',
    label: 'User Engagement Metrics',
    children: [
      {
        text: 'Page Views',
        tagKeyName: 'Page_Page_Views',
        value: 'Page_Page_Views',
        disabled: true,
      },
      {
        text: 'Bounce Rate',
        tagKeyName: 'Page_Bounce_Rate',
        value: 'Page_Bounce_Rate',
        disabled: true,
      },
      {
        text: 'Average Time on Page',
        tagKeyName: 'Page_Average_Time_on_Page',
        value: 'Page_Average_Time_on_Page',
        disabled: true,
      },
      {
        text: 'Conversion Rate',
        tagKeyName: 'Page_Conversion_Rate',
        value: 'Page_Conversion_Rate',
        disabled: true,
      },
      {
        text: 'Scroll Depth',
        tagKeyName: 'Page_Scroll_Depth',
        value: 'Page_Scroll_Depth',
        disabled: true,
      },
      {
        text: 'Engagement Actions',
        tagKeyName: 'Page_Engagement_Actions',
        value: 'Page_Engagement_Actions',
        disabled: true,
      },
      {
        text: 'Return Visits',
        tagKeyName: 'Page_Return_Visits',
        value: 'Page_Return_Visits',
        disabled: true,
      },
      {
        text: 'Interaction Events',
        tagKeyName: 'Page_Interaction_Events',
        value: 'Page_Interaction_Events',
        disabled: true,
      },
    ],
  },
  {
    groupName: 'Temporal Attributes',
    label: 'Temporal Attributes',
    children: [
      {
        text: 'Content Freshness',
        tagKeyName: 'Page_Content_Freshness',
        value: 'Page_Content_Freshness',
        disabled: true,
      },
      {
        text: 'Seasonality',
        tagKeyName: 'Page_Seasonality',
        value: 'Page_Seasonality',
        disabled: true,
      },
      {
        text: 'Time Since Last Update',
        tagKeyName: 'Page_Time_Since_Last_Update',
        value: 'Page_Time_Since_Last_Update',
        disabled: true,
      },
      {
        text: 'Event Timing',
        tagKeyName: 'Page_Event_Timing',
        value: 'Page_Event_Timing',
        disabled: true,
      },
      {
        text: "User's Local Time",
        tagKeyName: 'Page_Users_Local_Time',
        value: 'Page_Users_Local_Time',
        disabled: true,
      },
      {
        text: 'Offer Expiry',
        tagKeyName: 'Page_Offer_Expiry',
        value: 'Page_Offer_Expiry',
        disabled: true,
      },
      {
        text: 'Content Lifecycle Stage',
        tagKeyName: 'Page_Content_Lifecycle_Stage',
        value: 'Page_Content_Lifecycle_Stage',
        disabled: true,
      },
    ],
  },
  {
    groupName: 'Technical SEO Tags',
    label: 'Technical SEO Tags',
    children: [
      {
        text: 'Page Speed Score',
        tagKeyName: 'Page_Page_Speed_Score',
        value: 'Page_Page_Speed_Score',
        disabled: true,
      },
      {
        text: 'Mobile Usability Issues',
        tagKeyName: 'Page_Mobile_Usability_Issues',
        value: 'Page_Mobile_Usability_Issues',
        disabled: true,
      },
      {
        text: 'Largest Contentful Paint (LCP)',
        tagKeyName: 'Page_Largest_Contentful_Paint_LCP',
        value: 'Page_Largest_Contentful_Paint_LCP',
        disabled: true,
      },
      {
        text: 'First Input Delay (FID)',
        tagKeyName: 'Page_First_Input_Delay_FID',
        value: 'Page_First_Input_Delay_FID',
        disabled: true,
      },
      {
        text: 'Cumulative Layout Shift (CLS)',
        tagKeyName: 'Page_Cumulative_Layout_Shift_CLS',
        value: 'Page_Cumulative_Layout_Shift_CLS',
        disabled: true,
      },
      {
        text: 'Structured Data Errors',
        tagKeyName: 'Page_Structured_Data_Errors',
        value: 'Page_Structured_Data_Errors',
        disabled: true,
      },
      {
        text: 'Indexing Issues',
        tagKeyName: 'Page_Indexing_Issues',
        value: 'Page_Indexing_Issues',
        disabled: true,
      },
      {
        text: 'Robots.txt Compliance',
        tagKeyName: 'Page_Robots_txt_Compliance',
        value: 'Page_Robots_txt_Compliance',
        disabled: true,
      },
      {
        text: 'Sitemap Presence',
        tagKeyName: 'Page_Sitemap_Presence',
        value: 'Page_Sitemap_Presence',
        disabled: true,
      },
      {
        text: 'Security Issues',
        tagKeyName: 'Page_Security_Issues',
        value: 'Page_Security_Issues',
        disabled: true,
      },
    ],
  },
  {
    groupName: 'Social Media Tags',
    label: 'Social Media Tags',
    children: [
      {
        text: 'Open Graph Metadata',
        tagKeyName: 'Page_Open_Graph_Metadata',
        value: 'Page_Open_Graph_Metadata',
        disabled: true,
      },
      {
        text: 'Twitter Card Metadata',
        tagKeyName: 'Page_Twitter_Card_Metadata',
        value: 'Page_Twitter_Card_Metadata',
        disabled: true,
      },
      {
        text: 'Social Shares',
        tagKeyName: 'Page_Social_Shares',
        value: 'Page_Social_Shares',
        disabled: true,
      },
      {
        text: 'Comments/Reactions',
        tagKeyName: 'Page_Comments_Reactions',
        value: 'Page_Comments_Reactions',
        disabled: true,
      },
      {
        text: 'Influencer Engagement',
        tagKeyName: 'Page_Influencer_Engagement',
        value: 'Page_Influencer_Engagement',
        disabled: true,
      },
      {
        text: 'Hashtag Usage',
        tagKeyName: 'Page_Hashtag_Usage',
        value: 'Page_Hashtag_Usage',
        disabled: true,
      },
      {
        text: 'User-Generated Content',
        tagKeyName: 'Page_User_Generated_Content',
        value: 'Page_User_Generated_Content',
        disabled: true,
      },
      {
        text: 'Social Platform Presence',
        tagKeyName: 'Page_Social_Platform_Presence',
        value: 'Page_Social_Platform_Presence',
        disabled: true,
      },
    ],
  },
];

export const STATIC_IL_PAGE_TAG_DATA = {
  page_country: {
    filterKey: 'page_country',
    title: 'Page Country',
    options: [
      {
        text: 'USA',
        value: 'USA',
        type: 'Page_Country',
      },
      {
        text: 'Canada',
        value: 'Canada',
        type: 'Page_Country',
      },
      {
        text: 'UK',
        value: 'UK',
        type: 'Page_Country',
      },
      {
        text: 'Australia',
        value: 'Australia',
        type: 'Page_Country',
      },
      {
        text: 'India',
        value: 'India',
        type: 'Page_Country',
      },
    ],
  },
  page_state: {
    filterKey: 'page_state',
    title: 'Page State Province Region',
    options: [
      {
        text: 'California',
        value: 'California',
        type: 'page_state',
      },
      {
        text: 'Ontario',
        value: 'Ontario',
        type: 'page_state',
      },
      {
        text: 'Bavaria',
        value: 'Bavaria',
        type: 'page_state',
      },
      {
        text: 'New South Wales',
        value: 'New South Wales',
        type: 'page_state',
      },
      {
        text: 'Maharashtra',
        value: 'Maharashtra',
        type: 'page_state',
      },
    ],
  },
  page_city: {
    filterKey: 'page_city',
    title: 'Page City',
    options: [
      {
        text: 'New York',
        value: 'New York',
        type: 'Page_City',
      },
      {
        text: 'Toronto',
        value: 'Toronto',
        type: 'Page_City',
      },
      {
        text: 'Munich',
        value: 'Munich',
        type: 'Page_City',
      },
      {
        text: 'Sydney',
        value: 'Sydney',
        type: 'Page_City',
      },
      {
        text: 'Mumbai',
        value: 'Mumbai',
        type: 'Page_City',
      },
    ],
  },
  page_continent: {
    filterKey: 'page_continent',
    title: 'Page Continent',
    options: [
      {
        text: 'North America',
        value: 'North America',
        type: 'Page_Continent',
      },
      {
        text: 'Europe',
        value: 'Europe',
        type: 'Page_Continent',
      },
      {
        text: 'Asia',
        value: 'Asia',
        type: 'Page_Continent',
      },
      {
        text: 'Africa',
        value: 'Africa',
        type: 'Page_Continent',
      },
      {
        text: 'South America',
        value: 'South America',
        type: 'Page_Continent',
      },
    ],
  },
  page_language_locale: {
    filterKey: 'page_language_locale',
    title: 'Page Language Locale',
    options: [
      {
        text: 'en-US',
        value: 'en-US',
        type: 'Page_Language_Locale',
      },
      {
        text: 'en-GB',
        value: 'en-GB',
        type: 'Page_Language_Locale',
      },
      {
        text: 'fr-FR',
        value: 'fr-FR',
        type: 'Page_Language_Locale',
      },
      {
        text: 'es-ES',
        value: 'es-ES',
        type: 'Page_Language_Locale',
      },
    ],
  },
  page_domain: {
    filterKey: 'page_domain',
    title: 'Page Domain',
    options: [
      {
        text: 'www.example.com',
        value: 'www.example.com',
        type: 'Page_Domain',
      },
      {
        text: 'store.example.com',
        value: 'store.example.com',
        type: 'Page_Domain',
      },
    ],
  },
  page_subdomain: {
    filterKey: 'page_subdomain',
    title: 'Page Subdomain',
    options: [
      {
        text: 'blog',
        value: 'blog',
        type: 'Page_Subdomain',
      },
      {
        text: 'shop',
        value: 'shop',
        type: 'Page_Subdomain',
      },
      {
        text: 'support',
        value: 'support',
        type: 'Page_Subdomain',
      },
    ],
  },
  page_path_depth: {
    filterKey: 'page_path_depth',
    title: 'Page Path Depth',
    options: [
      {
        text: 'Level 1',
        value: 'Level 1',
        type: 'Page_Path_Depth',
      },
      {
        text: 'Level 2',
        value: 'Level 2',
        type: 'Page_Path_Depth',
      },
      {
        text: 'Level 3+',
        value: 'Level 3+',
        type: 'Page_Path_Depth',
      },
    ],
  },
  page_url_structure: {
    filterKey: 'page_url_structure',
    title: 'Page URL Structure',
    options: [
      {
        text: 'Flat',
        value: 'Flat',
        type: 'Page_URL_Structure',
      },
      {
        text: 'Hierarchical',
        value: 'Hierarchical',
        type: 'Page_URL_Structure',
      },
    ],
  },
  page_url_keywords: {
    filterKey: 'page_url_keywords',
    title: 'Page URL Keywords',
    options: [
      {
        text: 'Contains Product Name',
        value: 'Contains Product Name',
        type: 'Page_URL_Keywords',
      },
      {
        text: 'Contains Date',
        value: 'Contains Date',
        type: 'Page_URL_Keywords',
      },
      {
        text: 'Contains Category',
        value: 'Contains Category',
        type: 'Page_URL_Keywords',
      },
    ],
  },
  page_parameterization: {
    filterKey: 'page_parameterization',
    title: 'Page Parameterization',
    options: [
      {
        text: 'Clean URLs',
        value: 'Clean URLs',
        type: 'Page_Parameterization',
      },
      {
        text: 'Parameterized URLs',
        value: 'Parameterized URLs',
        type: 'Page_Parameterization',
      },
    ],
  },
  page_secure_protocol: {
    filterKey: 'page_secure_protocol',
    title: 'Page Secure Protocol',
    options: [
      {
        text: 'HTTPS',
        value: 'HTTPS',
        type: 'Page_Secure_Protocol',
      },
      {
        text: 'HTTP',
        value: 'HTTP',
        type: 'Page_Secure_Protocol',
      },
    ],
  },
  page_product_name: {
    filterKey: 'page_product_name',
    title: 'Page Product Name',
    options: [
      {
        text: 'iPhone 15 Pro Max',
        value: 'iPhone 15 Pro Max',
        type: 'Page_Product_Name',
      },
      {
        text: 'Galaxy S23 Ultra',
        value: 'Galaxy S23 Ultra',
        type: 'Page_Product_Name',
      },
    ],
  },
  page_product_id: {
    filterKey: 'page_product_id',
    title: 'Page Product ID SKU',
    options: [
      {
        text: 'SKU12345',
        value: 'SKU12345',
        type: 'Page_Product_ID',
      },
      {
        text: 'PID67890',
        value: 'PID67890',
        type: 'Page_Product_ID',
      },
    ],
  },
  page_product_category: {
    filterKey: 'page_product_category',
    title: 'Page Product Category',
    options: [
      {
        text: 'Electronics',
        value: 'Electronics',
        type: 'Page_Product_Category',
      },
      {
        text: 'Clothing',
        value: 'Clothing',
        type: 'Page_Product_Category',
      },
      {
        text: 'Home Appliances',
        value: 'Home Appliances',
        type: 'Page_Product_Category',
      },
    ],
  },
  page_product_subcategory: {
    filterKey: 'page_product_subcategory',
    title: 'Page Product Subcategory',
    options: [
      {
        text: 'Smartphones',
        value: 'Smartphones',
        type: 'Page_Product_Subcategory',
      },
      {
        text: 'Laptops',
        value: 'Laptops',
        type: 'Page_Product_Subcategory',
      },
      {
        text: "Men's Shoes",
        value: "Men's Shoes",
        type: 'Page_Product_Subcategory',
      },
    ],
  },
  page_product_type: {
    filterKey: 'page_product_type',
    title: 'Page Product Type',
    options: [
      {
        text: 'New Arrival',
        value: 'New Arrival',
        type: 'Page_Product_Type',
      },
      {
        text: 'Best Seller',
        value: 'Best Seller',
        type: 'Page_Product_Type',
      },
      {
        text: 'Limited Edition',
        value: 'Limited Edition',
        type: 'Page_Product_Type',
      },
    ],
  },
  page_brand: {
    filterKey: 'page_brand',
    title: 'Page Brand',
    options: [
      {
        text: 'Apple',
        value: 'Apple',
        type: 'Page_Brand',
      },
      {
        text: 'Samsung',
        value: 'Samsung',
        type: 'Page_Brand',
      },
      {
        text: 'Nike',
        value: 'Nike',
        type: 'Page_Brand',
      },
      {
        text: 'Sony',
        value: 'Sony',
        type: 'Page_Brand',
      },
    ],
  },
  page_price: {
    filterKey: 'page_price',
    title: 'Page Price',
    options: [
      {
        text: 'Budget',
        value: 'Budget',
        type: 'Page_Price',
      },
      {
        text: 'Mid-Range',
        value: 'Mid-Range',
        type: 'Page_Price',
      },
      {
        text: 'Premium',
        value: 'Premium',
        type: 'Page_Price',
      },
    ],
  },
  page_discount_level: {
    filterKey: 'page_discount_level',
    title: 'Page Discount Level',
    options: [
      {
        text: 'No Discount',
        value: 'No Discount',
        type: 'Page_Discount_Level',
      },
      {
        text: 'Low',
        value: 'Low',
        type: 'Page_Discount_Level',
      },
      {
        text: 'Medium',
        value: 'Medium',
        type: 'Page_Discount_Level',
      },
      {
        text: 'High',
        value: 'High',
        type: 'Page_Discount_Level',
      },
    ],
  },
  page_availability: {
    filterKey: 'page_availability',
    title: 'Page Availability',
    options: [
      {
        text: 'In Stock',
        value: 'In Stock',
        type: 'Page_Availability',
      },
      {
        text: 'Out of Stock',
        value: 'Out of Stock',
        type: 'Page_Availability',
      },
      {
        text: 'Pre-Order',
        value: 'Pre-Order',
        type: 'Page_Availability',
      },
      {
        text: 'Discontinued',
        value: 'Discontinued',
        type: 'Page_Availability',
      },
    ],
  },
  page_customer_rating: {
    filterKey: 'page_customer_rating',
    title: 'Page Customer Rating',
    options: [
      {
        text: 'Low',
        value: 'Low',
        type: 'Page_Customer_Rating',
      },
      {
        text: 'Medium',
        value: 'Medium',
        type: 'Page_Customer_Rating',
      },
      {
        text: 'High',
        value: 'High',
        type: 'Page_Customer_Rating',
      },
    ],
  },
  page_review_count: {
    filterKey: 'page_review_count',
    title: 'Page Review Count',
    options: [
      {
        text: 'Few',
        value: 'Few',
        type: 'Page_Review_Count',
      },
      {
        text: 'Moderate',
        value: 'Moderate',
        type: 'Page_Review_Count',
      },
      {
        text: 'Many',
        value: 'Many',
        type: 'Page_Review_Count',
      },
    ],
  },
  page_release_date: {
    filterKey: 'page_release_date',
    title: 'Page Release Date',
    options: [
      {
        text: 'New',
        value: 'New',
        type: 'Page_Release_Date',
      },
      {
        text: 'Recent',
        value: 'Recent',
        type: 'Page_Release_Date',
      },
      {
        text: 'Older',
        value: 'Older',
        type: 'Page_Release_Date',
      },
    ],
  },
  page_product_attributes: {
    filterKey: 'page_product_attributes',
    title: 'Page Product Attributes',
    options: [
      {
        text: 'Color',
        value: 'Color',
        type: 'Page_Product_Attributes',
      },
      {
        text: 'Size',
        value: 'Size',
        type: 'Page_Product_Attributes',
      },
      {
        text: 'Material',
        value: 'Material',
        type: 'Page_Product_Attributes',
      },
    ],
  },
  page_energy_efficiency_rating: {
    filterKey: 'page_energy_efficiency_rating',
    title: 'Page Energy Efficiency Rating',
    options: [
      {
        text: 'A+++',
        value: 'A+++',
        type: 'Page_Energy_Efficiency_Rating',
      },
      {
        text: 'A++',
        value: 'A++',
        type: 'Page_Energy_Efficiency_Rating',
      },
      {
        text: 'A+',
        value: 'A+',
        type: 'Page_Energy_Efficiency_Rating',
      },
      {
        text: 'A',
        value: 'A',
        type: 'Page_Energy_Efficiency_Rating',
      },
    ],
  },
  page_warranty_period: {
    filterKey: 'page_warranty_period',
    title: 'Page Warranty Period',
    options: [
      {
        text: 'Short',
        value: 'Short',
        type: 'Page_Warranty_Period',
      },
      {
        text: 'Standard',
        value: 'Standard',
        type: 'Page_Warranty_Period',
      },
      {
        text: 'Extended',
        value: 'Extended',
        type: 'Page_Warranty_Period',
      },
    ],
  },
  page_content_type: {
    filterKey: 'page_content_type',
    title: 'Page Content Type',
    options: [
      {
        text: 'Article',
        value: 'Article',
        type: 'Page_Content_Type',
      },
      {
        text: 'Blog Post',
        value: 'Blog Post',
        type: 'Page_Content_Type',
      },
      {
        text: 'Product Page',
        value: 'Product Page',
        type: 'Page_Content_Type',
      },
      {
        text: 'Landing Page',
        value: 'Landing Page',
        type: 'Page_Content_Type',
      },
      {
        text: 'Video',
        value: 'Video',
        type: 'Page_Content_Type',
      },
    ],
  },
  page_publish_date: {
    filterKey: 'page_publish_date',
    title: 'Page Publish Date',
    options: [
      {
        text: 'Today',
        value: 'Today',
        type: 'Page_Publish_Date',
      },
      {
        text: 'This Week',
        value: 'This Week',
        type: 'Page_Publish_Date',
      },
      {
        text: 'This Month',
        value: 'This Month',
        type: 'Page_Publish_Date',
      },
      {
        text: 'Older',
        value: 'Older',
        type: 'Page_Publish_Date',
      },
    ],
  },
  page_update_frequency: {
    filterKey: 'page_update_frequency',
    title: 'Page Update Frequency',
    options: [
      {
        text: 'Daily',
        value: 'Daily',
        type: 'Page_Update_Frequency',
      },
      {
        text: 'Weekly',
        value: 'Weekly',
        type: 'Page_Update_Frequency',
      },
      {
        text: 'Monthly',
        value: 'Monthly',
        type: 'Page_Update_Frequency',
      },
      {
        text: 'Rarely',
        value: 'Rarely',
        type: 'Page_Update_Frequency',
      },
    ],
  },
  page_author: {
    filterKey: 'page_author',
    title: 'Page Author',
    options: [
      {
        text: 'Staff Writer',
        value: 'Staff Writer',
        type: 'Page_Author',
      },
      {
        text: 'Guest Author',
        value: 'Guest Author',
        type: 'Page_Author',
      },
      {
        text: 'Admin',
        value: 'Admin',
        type: 'Page_Author',
      },
    ],
  },
  page_topic_subject: {
    filterKey: 'page_topic_subject',
    title: 'Page Topic Subject',
    options: [
      {
        text: 'Technology',
        value: 'Technology',
        type: 'Page_Topic_Subject',
      },
      {
        text: 'Health',
        value: 'Health',
        type: 'Page_Topic_Subject',
      },
      {
        text: 'Finance',
        value: 'Finance',
        type: 'Page_Topic_Subject',
      },
      {
        text: 'Education',
        value: 'Education',
        type: 'Page_Topic_Subject',
      },
      {
        text: 'Lifestyle',
        value: 'Lifestyle',
        type: 'Page_Topic_Subject',
      },
    ],
  },
  page_reading_level: {
    filterKey: 'page_reading_level',
    title: 'Page Reading Level',
    options: [
      {
        text: 'Easy',
        value: 'Easy',
        type: 'Page_Reading_Level',
      },
      {
        text: 'Intermediate',
        value: 'Intermediate',
        type: 'Page_Reading_Level',
      },
      {
        text: 'Advanced',
        value: 'Advanced',
        type: 'Page_Reading_Level',
      },
    ],
  },
  page_word_count: {
    filterKey: 'page_word_count',
    title: 'Page Word Count',
    options: [
      {
        text: 'Short',
        value: 'Short',
        type: 'Page_Word_Count',
      },
      {
        text: 'Medium',
        value: 'Medium',
        type: 'Page_Word_Count',
      },
      {
        text: 'Long',
        value: 'Long',
        type: 'Page_Word_Count',
      },
    ],
  },
  page_multimedia_content: {
    filterKey: 'page_multimedia_content',
    title: 'Page Multimedia Content',
    options: [
      {
        text: 'Images',
        value: 'Images',
        type: 'Page_Multimedia_Content',
      },
      {
        text: 'Videos',
        value: 'Videos',
        type: 'Page_Multimedia_Content',
      },
      {
        text: 'Infographics',
        value: 'Infographics',
        type: 'Page_Multimedia_Content',
      },
      {
        text: 'None',
        value: 'None',
        type: 'Page_Multimedia_Content',
      },
    ],
  },
  page_language: {
    filterKey: 'page_language',
    title: 'Page Language',
    options: [
      {
        text: 'English',
        value: 'English',
        type: 'Page_Language',
      },
      {
        text: 'Spanish',
        value: 'Spanish',
        type: 'Page_Language',
      },
      {
        text: 'French',
        value: 'French',
        type: 'Page_Language',
      },
      {
        text: 'German',
        value: 'German',
        type: 'Page_Language',
      },
    ],
  },
  page_engagement_level: {
    filterKey: 'page_engagement_level',
    title: 'Page Engagement Level',
    options: [
      {
        text: 'Low Engagement',
        value: 'Low Engagement',
        type: 'Page_Engagement_Level',
      },
      {
        text: 'Medium Engagement',
        value: 'Medium Engagement',
        type: 'Page_Engagement_Level',
      },
      {
        text: 'High Engagement',
        value: 'High Engagement',
        type: 'Page_Engagement_Level',
      },
    ],
  },
  page_content_format: {
    filterKey: 'page_content_format',
    title: 'Page Content Format',
    options: [
      {
        text: 'Listicle',
        value: 'Listicle',
        type: 'Page_Content_Format',
      },
      {
        text: 'How-To Guide',
        value: 'How-To Guide',
        type: 'Page_Content_Format',
      },
      {
        text: 'Case Study',
        value: 'Case Study',
        type: 'Page_Content_Format',
      },
      {
        text: 'Interview',
        value: 'Interview',
        type: 'Page_Content_Format',
      },
    ],
  },
  page_social_proof: {
    filterKey: 'page_social_proof',
    title: 'Page Social Proof',
    options: [
      {
        text: 'Testimonials',
        value: 'Testimonials',
        type: 'Page_Social_Proof',
      },
      {
        text: 'User Reviews',
        value: 'User Reviews',
        type: 'Page_Social_Proof',
      },
      {
        text: 'Expert Opinions',
        value: 'Expert Opinions',
        type: 'Page_Social_Proof',
      },
    ],
  },
  page_meta_title_length: {
    filterKey: 'page_meta_title_length',
    title: 'Page Meta Title Length',
    options: [
      {
        text: 'Optimal',
        value: 'Optimal',
        type: 'Page_Meta_Title_Length',
      },
      {
        text: 'Too Short',
        value: 'Too Short',
        type: 'Page_Meta_Title_Length',
      },
      {
        text: 'Too Long',
        value: 'Too Long',
        type: 'Page_Meta_Title_Length',
      },
    ],
  },
  page_meta_description_presence: {
    filterKey: 'page_meta_description_presence',
    title: 'Page Meta Description Presence',
    options: [
      {
        text: 'Present',
        value: 'Present',
        type: 'Page_Meta_Description_Presence',
      },
      {
        text: 'Absent',
        value: 'Absent',
        type: 'Page_Meta_Description_Presence',
      },
    ],
  },
  page_header_tags_usage: {
    filterKey: 'page_header_tags_usage',
    title: 'Page Header Tags Usage',
    options: [
      {
        text: 'Proper H1 Usage',
        value: 'Proper H1 Usage',
        type: 'Page_Header_Tags_Usage',
      },
      {
        text: 'Multiple H1s',
        value: 'Multiple H1s',
        type: 'Page_Header_Tags_Usage',
      },
      {
        text: 'Missing H1',
        value: 'Missing H1',
        type: 'Page_Header_Tags_Usage',
      },
    ],
  },
  page_canonical_tag: {
    filterKey: 'page_canonical_tag',
    title: 'Page Canonical Tag',
    options: [
      {
        text: 'Correct Canonical',
        value: 'Correct Canonical',
        type: 'Page_Canonical_Tag',
      },
      {
        text: 'Incorrect Canonical',
        value: 'Incorrect Canonical',
        type: 'Page_Canonical_Tag',
      },
      {
        text: 'Missing Canonical',
        value: 'Missing Canonical',
        type: 'Page_Canonical_Tag',
      },
    ],
  },
  page_robots_meta_tag: {
    filterKey: 'page_robots_meta_tag',
    title: 'Page Robots Meta Tag',
    options: [
      {
        text: 'Index',
        value: 'Index',
        type: 'Page_Robots_Meta_Tag',
      },
      {
        text: 'Noindex',
        value: 'Noindex',
        type: 'Page_Robots_Meta_Tag',
      },
      {
        text: 'Nofollow',
        value: 'Nofollow',
        type: 'Page_Robots_Meta_Tag',
      },
    ],
  },
  page_page_load_speed: {
    filterKey: 'page_page_load_speed',
    title: 'Page Page Load Speed',
    options: [
      {
        text: 'Fast',
        value: 'Fast',
        type: 'Page_Page_Load_Speed',
      },
      {
        text: 'Average',
        value: 'Average',
        type: 'Page_Page_Load_Speed',
      },
      {
        text: 'Slow',
        value: 'Slow',
        type: 'Page_Page_Load_Speed',
      },
    ],
  },
  page_ssl_certificate: {
    filterKey: 'page_ssl_certificate',
    title: 'Page SSL Certificate',
    options: [
      {
        text: 'Valid',
        value: 'Valid',
        type: 'Page_SSL_Certificate',
      },
      {
        text: 'Expired',
        value: 'Expired',
        type: 'Page_SSL_Certificate',
      },
      {
        text: 'Not Present',
        value: 'Not Present',
        type: 'Page_SSL_Certificate',
      },
    ],
  },
  page_schema_types: {
    filterKey: 'page_schema_types',
    title: 'Page Schema Types',
    options: [
      {
        text: 'Product',
        value: 'Product',
        type: 'Page_Schema_Types',
      },
      {
        text: 'Article',
        value: 'Article',
        type: 'Page_Schema_Types',
      },
      {
        text: 'BreadcrumbList',
        value: 'BreadcrumbList',
        type: 'Page_Schema_Types',
      },
      {
        text: 'FAQPage',
        value: 'FAQPage',
        type: 'Page_Schema_Types',
      },
      {
        text: 'Review',
        value: 'Review',
        type: 'Page_Schema_Types',
      },
      {
        text: 'Event',
        value: 'Event',
        type: 'Page_Schema_Types',
      },
      {
        text: 'Organization',
        value: 'Organization',
        type: 'Page_Schema_Types',
      },
      {
        text: 'LocalBusiness',
        value: 'LocalBusiness',
        type: 'Page_Schema_Types',
      },
      {
        text: 'Person',
        value: 'Person',
        type: 'Page_Schema_Types',
      },
      {
        text: 'Recipe',
        value: 'Recipe',
        type: 'Page_Schema_Types',
      },
      {
        text: 'JobPosting',
        value: 'JobPosting',
        type: 'Page_Schema_Types',
      },
      {
        text: 'Course',
        value: 'Course',
        type: 'Page_Schema_Types',
      },
      {
        text: 'SoftwareApplication',
        value: 'SoftwareApplication',
        type: 'Page_Schema_Types',
      },
    ],
  },
  page_product_schema_properties: {
    filterKey: 'page_product_schema_properties',
    title: 'Page Product Schema Properties',
    options: [
      {
        text: 'name',
        value: 'name',
        type: 'Page_Product_Schema_Properties',
      },
      {
        text: 'image',
        value: 'image',
        type: 'Page_Product_Schema_Properties',
      },
      {
        text: 'description',
        value: 'description',
        type: 'Page_Product_Schema_Properties',
      },
      {
        text: 'sku',
        value: 'sku',
        type: 'Page_Product_Schema_Properties',
      },
      {
        text: 'brand',
        value: 'brand',
        type: 'Page_Product_Schema_Properties',
      },
      {
        text: 'offers',
        value: 'offers',
        type: 'Page_Product_Schema_Properties',
      },
    ],
  },
  page_article_schema_properties: {
    filterKey: 'page_article_schema_properties',
    title: 'Page Article Schema Properties',
    options: [
      {
        text: 'headline',
        value: 'headline',
        type: 'Page_Article_Schema_Properties',
      },
      {
        text: 'author',
        value: 'author',
        type: 'Page_Article_Schema_Properties',
      },
      {
        text: 'datePublished',
        value: 'datePublished',
        type: 'Page_Article_Schema_Properties',
      },
      {
        text: 'dateModified',
        value: 'dateModified',
        type: 'Page_Article_Schema_Properties',
      },
      {
        text: 'mainEntityOfPage',
        value: 'mainEntityOfPage',
        type: 'Page_Article_Schema_Properties',
      },
    ],
  },
  page_faqpage_schema_presence: {
    filterKey: 'page_faqpage_schema_presence',
    title: 'Page FAQPage Schema Presence',
    options: [
      {
        text: 'Yes',
        value: 'Yes',
        type: 'Page_FAQPage_Schema_Presence',
      },
      {
        text: 'No',
        value: 'No',
        type: 'Page_FAQPage_Schema_Presence',
      },
    ],
  },
  page_breadcrumblist_schema_presence: {
    filterKey: 'page_breadcrumblist_schema_presence',
    title: 'Page BreadcrumbList Schema Presence',
    options: [
      {
        text: 'Yes',
        value: 'Yes',
        type: 'Page_BreadcrumbList_Schema_Presence',
      },
      {
        text: 'No',
        value: 'No',
        type: 'Page_BreadcrumbList_Schema_Presence',
      },
    ],
  },
  page_review_schema_properties: {
    filterKey: 'page_review_schema_properties',
    title: 'Page Review Schema Properties',
    options: [
      {
        text: 'reviewRating',
        value: 'reviewRating',
        type: 'Page_Review_Schema_Properties',
      },
      {
        text: 'author',
        value: 'author',
        type: 'Page_Review_Schema_Properties',
      },
      {
        text: 'reviewBody',
        value: 'reviewBody',
        type: 'Page_Review_Schema_Properties',
      },
    ],
  },
  page_event_schema_properties: {
    filterKey: 'page_event_schema_properties',
    title: 'Page Event Schema Properties',
    options: [
      {
        text: 'name',
        value: 'name',
        type: 'Page_Event_Schema_Properties',
      },
      {
        text: 'startDate',
        value: 'startDate',
        type: 'Page_Event_Schema_Properties',
      },
      {
        text: 'location',
        value: 'location',
        type: 'Page_Event_Schema_Properties',
      },
    ],
  },
  page_aggregaterating: {
    filterKey: 'page_aggregaterating',
    title: 'Page AggregateRating',
    options: [
      {
        text: 'Low',
        value: 'Low',
        type: 'Page_AggregateRating',
      },
      {
        text: 'Medium',
        value: 'Medium',
        type: 'Page_AggregateRating',
      },
      {
        text: 'High',
        value: 'High',
        type: 'Page_AggregateRating',
      },
    ],
  },
  page_jobposting_schema_presence: {
    filterKey: 'page_jobposting_schema_presence',
    title: 'Page JobPosting Schema Presence',
    options: [
      {
        text: 'Yes',
        value: 'Yes',
        type: 'Page_JobPosting_Schema_Presence',
      },
      {
        text: 'No',
        value: 'No',
        type: 'Page_JobPosting_Schema_Presence',
      },
    ],
  },
  page_visit_frequency: {
    filterKey: 'page_visit_frequency',
    title: 'Page Visit Frequency',
    options: [
      {
        text: 'Rare',
        value: 'Rare',
        type: 'Page_Visit_Frequency',
      },
      {
        text: 'Occasional',
        value: 'Occasional',
        type: 'Page_Visit_Frequency',
      },
      {
        text: 'Frequent',
        value: 'Frequent',
        type: 'Page_Visit_Frequency',
      },
    ],
  },
  page_time_of_visit: {
    filterKey: 'page_time_of_visit',
    title: 'Page Time Of Visit',
    options: [
      {
        text: 'Morning',
        value: 'Morning',
        type: 'Page_Time_Of_Visit',
      },
      {
        text: 'Afternoon',
        value: 'Afternoon',
        type: 'Page_Time_Of_Visit',
      },
      {
        text: 'Evening',
        value: 'Evening',
        type: 'Page_Time_Of_Visit',
      },
      {
        text: 'Night',
        value: 'Night',
        type: 'Page_Time_Of_Visit',
      },
    ],
  },
  page_day_of_week: {
    filterKey: 'page_day_of_week',
    title: 'Page Day Of Week',
    options: [
      {
        text: 'Weekday',
        value: 'Weekday',
        type: 'Page_Day_Of_Week',
      },
      {
        text: 'Weekend',
        value: 'Weekend',
        type: 'Page_Day_Of_Week',
      },
    ],
  },
  page_device_type: {
    filterKey: 'page_device_type',
    title: 'Page Device Type',
    options: [
      {
        text: 'Desktop',
        value: 'Desktop',
        type: 'Page_Device_Type',
      },
      {
        text: 'Mobile',
        value: 'Mobile',
        type: 'Page_Device_Type',
      },
      {
        text: 'Tablet',
        value: 'Tablet',
        type: 'Page_Device_Type',
      },
    ],
  },
  page_browser_type: {
    filterKey: 'page_browser_type',
    title: 'Page Browser Type',
    options: [
      {
        text: 'Chrome',
        value: 'Chrome',
        type: 'Page_Browser_Type',
      },
      {
        text: 'Firefox',
        value: 'Firefox',
        type: 'Page_Browser_Type',
      },
      {
        text: 'Safari',
        value: 'Safari',
        type: 'Page_Browser_Type',
      },
      {
        text: 'Edge',
        value: 'Edge',
        type: 'Page_Browser_Type',
      },
    ],
  },
  page_traffic_source: {
    filterKey: 'page_traffic_source',
    title: 'Page Traffic Source',
    options: [
      {
        text: 'Organic Search',
        value: 'Organic Search',
        type: 'Page_Traffic_Source',
      },
      {
        text: 'Direct',
        value: 'Direct',
        type: 'Page_Traffic_Source',
      },
      {
        text: 'Referral',
        value: 'Referral',
        type: 'Page_Traffic_Source',
      },
      {
        text: 'Social Media',
        value: 'Social Media',
        type: 'Page_Traffic_Source',
      },
      {
        text: 'Email',
        value: 'Email',
        type: 'Page_Traffic_Source',
      },
    ],
  },
  page_behavioral_engagement_level: {
    filterKey: 'page_behavioral_engagement_level',
    title: 'Page Engagement Level',
    options: [
      {
        text: 'Low',
        value: 'Low',
        type: 'Page_Behavioral_Engagement_Level',
      },
      {
        text: 'Medium',
        value: 'Medium',
        type: 'Page_Behavioral_Engagement_Level',
      },
      {
        text: 'High',
        value: 'High',
        type: 'Page_Behavioral_Engagement_Level',
      },
    ],
  },
  page_conversion_behavior: {
    filterKey: 'page_conversion_behavior',
    title: 'Page Conversion Behavior',
    options: [
      {
        text: 'Added to Cart',
        value: 'Added to Cart',
        type: 'Page_Conversion_Behavior',
      },
      {
        text: 'Completed Purchase',
        value: 'Completed Purchase',
        type: 'Page_Conversion_Behavior',
      },
      {
        text: 'Form Submission',
        value: 'Form Submission',
        type: 'Page_Conversion_Behavior',
      },
    ],
  },
  page_new_vs_returning_visitor: {
    filterKey: 'page_new_vs_returning_visitor',
    title: 'Page New Vs Returning Visitor',
    options: [
      {
        text: 'New',
        value: 'New',
        type: 'Page_New_Vs_Returning_Visitor',
      },
      {
        text: 'Returning',
        value: 'Returning',
        type: 'Page_New_Vs_Returning_Visitor',
      },
    ],
  },
  page_session_duration: {
    filterKey: 'page_session_duration',
    title: 'Page Session Duration',
    options: [
      {
        text: 'Short',
        value: 'Short',
        type: 'Page_Session_Duration',
      },
      {
        text: 'Medium',
        value: 'Medium',
        type: 'Page_Session_Duration',
      },
      {
        text: 'Long',
        value: 'Long',
        type: 'Page_Session_Duration',
      },
    ],
  },
  page_sentiment_analysis: {
    filterKey: 'page_sentiment_analysis',
    title: 'Page Sentiment Analysis',
    options: [
      {
        text: 'Negative',
        value: 'Negative',
        type: 'Page_Sentiment_Analysis',
      },
      {
        text: 'Neutral',
        value: 'Neutral',
        type: 'Page_Sentiment_Analysis',
      },
      {
        text: 'Positive',
        value: 'Positive',
        type: 'Page_Sentiment_Analysis',
      },
    ],
  },
  page_topic_categories: {
    filterKey: 'page_topic_categories',
    title: 'Page Topic Categories',
    options: [
      {
        text: 'Machine Learning',
        value: 'Machine Learning',
        type: 'Page_Topic_Categories',
      },
      {
        text: 'Renewable Energy',
        value: 'Renewable Energy',
        type: 'Page_Topic_Categories',
      },
      {
        text: 'Personal Finance',
        value: 'Personal Finance',
        type: 'Page_Topic_Categories',
      },
    ],
  },
  page_key_entities: {
    filterKey: 'page_key_entities',
    title: 'Page Key Entities',
    options: [
      {
        text: 'Companies',
        value: 'Companies',
        type: 'Page_Key_Entities',
      },
      {
        text: 'People',
        value: 'People',
        type: 'Page_Key_Entities',
      },
      {
        text: 'Products',
        value: 'Products',
        type: 'Page_Key_Entities',
      },
    ],
  },
  page_content_summary: {
    filterKey: 'page_content_summary',
    title: 'Page Content Summary',
    options: [
      {
        text: 'Brief Overview',
        value: 'Brief Overview',
        type: 'Page_Content_Summary',
      },
      {
        text: 'In-depth Analysis',
        value: 'In-depth Analysis',
        type: 'Page_Content_Summary',
      },
    ],
  },
  page_reading_complexity: {
    filterKey: 'page_reading_complexity',
    title: 'Page Reading Complexity',
    options: [
      {
        text: 'Simple',
        value: 'Simple',
        type: 'Page_Reading_Complexity',
      },
      {
        text: 'Intermediate',
        value: 'Intermediate',
        type: 'Page_Reading_Complexity',
      },
      {
        text: 'Advanced',
        value: 'Advanced',
        type: 'Page_Reading_Complexity',
      },
    ],
  },
  page_emotional_tone: {
    filterKey: 'page_emotional_tone',
    title: 'Page Emotional Tone',
    options: [
      {
        text: 'Informative',
        value: 'Informative',
        type: 'Page_Emotional_Tone',
      },
      {
        text: 'Persuasive',
        value: 'Persuasive',
        type: 'Page_Emotional_Tone',
      },
      {
        text: 'Entertaining',
        value: 'Entertaining',
        type: 'Page_Emotional_Tone',
      },
      {
        text: 'Urgent',
        value: 'Urgent',
        type: 'Page_Emotional_Tone',
      },
    ],
  },
  page_user_intent: {
    filterKey: 'page_user_intent',
    title: 'Page User Intent',
    options: [
      {
        text: 'Informational',
        value: 'Informational',
        type: 'Page_User_Intent',
      },
      {
        text: 'Navigational',
        value: 'Navigational',
        type: 'Page_User_Intent',
      },
      {
        text: 'Transactional',
        value: 'Transactional',
        type: 'Page_User_Intent',
      },
      {
        text: 'Commercial Investigation',
        value: 'Commercial Investigation',
        type: 'Page_User_Intent',
      },
    ],
  },
  page_faqs_extracted: {
    filterKey: 'page_faqs_extracted',
    title: 'Page FAQs Extracted',
    options: [
      {
        text: 'Contains FAQs',
        value: 'Contains FAQs',
        type: 'Page_FAQs_Extracted',
      },
      {
        text: 'Does Not Contain FAQs',
        value: 'Does Not Contain FAQs',
        type: 'Page_FAQs_Extracted',
      },
    ],
  },
  page_content_gaps: {
    filterKey: 'page_content_gaps',
    title: 'Page Content Gaps',
    options: [
      {
        text: 'Identified',
        value: 'Identified',
        type: 'Page_Content_Gaps',
      },
      {
        text: 'None',
        value: 'None',
        type: 'Page_Content_Gaps',
      },
    ],
  },
  page_internal_link_count: {
    filterKey: 'page_internal_link_count',
    title: 'Page Internal Link Count',
    options: [
      {
        text: 'Few',
        value: 'Few',
        type: 'Page_Internal_Link_Count',
      },
      {
        text: 'Moderate',
        value: 'Moderate',
        type: 'Page_Internal_Link_Count',
      },
      {
        text: 'Many',
        value: 'Many',
        type: 'Page_Internal_Link_Count',
      },
    ],
  },
  page_external_link_count: {
    filterKey: 'page_external_link_count',
    title: 'Page External Link Count',
    options: [
      {
        text: 'None',
        value: 'None',
        type: 'Page_External_Link_Count',
      },
      {
        text: 'Few',
        value: 'Few',
        type: 'Page_External_Link_Count',
      },
      {
        text: 'Several',
        value: 'Several',
        type: 'Page_External_Link_Count',
      },
    ],
  },
  page_backlink_count: {
    filterKey: 'page_backlink_count',
    title: 'Page Backlink Count',
    options: [
      {
        text: 'Low',
        value: 'Low',
        type: 'Page_Backlink_Count',
      },
      {
        text: 'Medium',
        value: 'Medium',
        type: 'Page_Backlink_Count',
      },
      {
        text: 'High',
        value: 'High',
        type: 'Page_Backlink_Count',
      },
    ],
  },
  page_link_quality: {
    filterKey: 'page_link_quality',
    title: 'Page Link Quality',
    options: [
      {
        text: 'High Authority',
        value: 'High Authority',
        type: 'Page_Link_Quality',
      },
      {
        text: 'Medium Authority',
        value: 'Medium Authority',
        type: 'Page_Link_Quality',
      },
      {
        text: 'Low Authority',
        value: 'Low Authority',
        type: 'Page_Link_Quality',
      },
    ],
  },
  page_anchor_text_diversity: {
    filterKey: 'page_anchor_text_diversity',
    title: 'Page Anchor Text Diversity',
    options: [
      {
        text: 'Branded',
        value: 'Branded',
        type: 'Page_Anchor_Text_Diversity',
      },
      {
        text: 'Exact Match',
        value: 'Exact Match',
        type: 'Page_Anchor_Text_Diversity',
      },
      {
        text: 'Partial Match',
        value: 'Partial Match',
        type: 'Page_Anchor_Text_Diversity',
      },
      {
        text: 'Generic',
        value: 'Generic',
        type: 'Page_Anchor_Text_Diversity',
      },
    ],
  },
  page_broken_links: {
    filterKey: 'page_broken_links',
    title: 'Page Broken Links',
    options: [
      {
        text: 'None',
        value: 'None',
        type: 'Page_Broken_Links',
      },
      {
        text: 'Some',
        value: 'Some',
        type: 'Page_Broken_Links',
      },
      {
        text: 'Many',
        value: 'Many',
        type: 'Page_Broken_Links',
      },
    ],
  },
  page_nofollow_links: {
    filterKey: 'page_nofollow_links',
    title: 'Page Nofollow Links',
    options: [
      {
        text: 'Present',
        value: 'Present',
        type: 'Page_Nofollow_Links',
      },
      {
        text: 'Absent',
        value: 'Absent',
        type: 'Page_Nofollow_Links',
      },
    ],
  },
  page_ugc_sponsored_links: {
    filterKey: 'page_ugc_sponsored_links',
    title: 'Page UGC/Sponsored Links',
    options: [
      {
        text: 'Present',
        value: 'Present',
        type: 'Page_UGC_Sponsored_Links',
      },
      {
        text: 'Absent',
        value: 'Absent',
        type: 'Page_UGC_Sponsored_Links',
      },
    ],
  },
  page_redirect_links: {
    filterKey: 'page_redirect_links',
    title: 'Page Redirect Links',
    options: [
      {
        text: 'None',
        value: 'None',
        type: 'Page_Redirect_Links',
      },
      {
        text: '301 Redirects',
        value: '301 Redirects',
        type: 'Page_Redirect_Links',
      },
      {
        text: '302 Redirects',
        value: '302 Redirects',
        type: 'Page_Redirect_Links',
      },
    ],
  },
  page_price_range: {
    filterKey: 'page_price_range',
    title: 'Page Price Range',
    options: [
      {
        text: 'Under $25',
        value: 'Under $25',
        type: 'Page_Price_Range',
      },
      {
        text: '$25-$50',
        value: '$25-$50',
        type: 'Page_Price_Range',
      },
      {
        text: '$50-$100',
        value: '$50-$100',
        type: 'Page_Price_Range',
      },
      {
        text: 'Over $100',
        value: 'Over $100',
        type: 'Page_Price_Range',
      },
    ],
  },
  page_discount_offered: {
    filterKey: 'page_discount_offered',
    title: 'Page Discount Offered',
    options: [
      {
        text: 'None',
        value: 'None',
        type: 'Page_Discount_Offered',
      },
      {
        text: 'Low',
        value: 'Low',
        type: 'Page_Discount_Offered',
      },
      {
        text: 'Medium',
        value: 'Medium',
        type: 'Page_Discount_Offered',
      },
      {
        text: 'High',
        value: 'High',
        type: 'Page_Discount_Offered',
      },
    ],
  },
  page_stock_availability: {
    filterKey: 'page_stock_availability',
    title: 'Page Stock Availability',
    options: [
      {
        text: 'In Stock',
        value: 'In Stock',
        type: 'Page_Stock_Availability',
      },
      {
        text: 'Low Stock',
        value: 'Low Stock',
        type: 'Page_Stock_Availability',
      },
      {
        text: 'Out of Stock',
        value: 'Out of Stock',
        type: 'Page_Stock_Availability',
      },
    ],
  },
  page_shipping_options: {
    filterKey: 'page_shipping_options',
    title: 'Page Shipping Options',
    options: [
      {
        text: 'Free Shipping',
        value: 'Free Shipping',
        type: 'Page_Shipping_Options',
      },
      {
        text: 'Standard Shipping',
        value: 'Standard Shipping',
        type: 'Page_Shipping_Options',
      },
      {
        text: 'Expedited Shipping',
        value: 'Expedited Shipping',
        type: 'Page_Shipping_Options',
      },
    ],
  },
  page_return_policy: {
    filterKey: 'page_return_policy',
    title: 'Page Return Policy',
    options: [
      {
        text: 'Free Returns',
        value: 'Free Returns',
        type: 'Page_Return_Policy',
      },
      {
        text: '30-Day Returns',
        value: '30-Day Returns',
        type: 'Page_Return_Policy',
      },
      {
        text: 'No Returns',
        value: 'No Returns',
        type: 'Page_Return_Policy',
      },
    ],
  },
  page_payment_methods: {
    filterKey: 'page_payment_methods',
    title: 'Page Payment Methods',
    options: [
      {
        text: 'Credit Card',
        value: 'Credit Card',
        type: 'Page_Payment_Methods',
      },
      {
        text: 'PayPal',
        value: 'PayPal',
        type: 'Page_Payment_Methods',
      },
      {
        text: 'Buy Now Pay Later',
        value: 'Buy Now Pay Later',
        type: 'Page_Payment_Methods',
      },
    ],
  },
  page_customer_loyalty_program: {
    filterKey: 'page_customer_loyalty_program',
    title: 'Page Customer Loyalty Program',
    options: [
      {
        text: 'Points System',
        value: 'Points System',
        type: 'Page_Customer_Loyalty_Program',
      },
      {
        text: 'VIP Discounts',
        value: 'VIP Discounts',
        type: 'Page_Customer_Loyalty_Program',
      },
      {
        text: 'Exclusive Access',
        value: 'Exclusive Access',
        type: 'Page_Customer_Loyalty_Program',
      },
    ],
  },
  page_product_bundles: {
    filterKey: 'page_product_bundles',
    title: 'Page Product Bundles',
    options: [
      {
        text: 'Bundle Available',
        value: 'Bundle Available',
        type: 'Page_Product_Bundles',
      },
      {
        text: 'No Bundle',
        value: 'No Bundle',
        type: 'Page_Product_Bundles',
      },
    ],
  },
  page_subscription_options: {
    filterKey: 'page_subscription_options',
    title: 'Page Subscription Options',
    options: [
      {
        text: 'Subscribe & Save',
        value: 'Subscribe & Save',
        type: 'Page_Subscription_Options',
      },
      {
        text: 'One-Time Purchase',
        value: 'One-Time Purchase',
        type: 'Page_Subscription_Options',
      },
    ],
  },
  page_gift_options: {
    filterKey: 'page_gift_options',
    title: 'Page Gift Options',
    options: [
      {
        text: 'Gift Wrapping Available',
        value: 'Gift Wrapping Available',
        type: 'Page_Gift_Options',
      },
      {
        text: 'Gift Cards Available',
        value: 'Gift Cards Available',
        type: 'Page_Gift_Options',
      },
    ],
  },
  page_page_views: {
    filterKey: 'page_page_views',
    title: 'Page Views',
    options: [
      {
        text: 'Low',
        value: 'Low',
        type: 'Page_Page_Views',
      },
      {
        text: 'Medium',
        value: 'Medium',
        type: 'Page_Page_Views',
      },
      {
        text: 'High',
        value: 'High',
        type: 'Page_Page_Views',
      },
    ],
  },
  page_bounce_rate: {
    filterKey: 'page_bounce_rate',
    title: 'Bounce Rate',
    options: [
      {
        text: 'Low',
        value: 'Low',
        type: 'Page_Bounce_Rate',
      },
      {
        text: 'Medium',
        value: 'Medium',
        type: 'Page_Bounce_Rate',
      },
      {
        text: 'High',
        value: 'High',
        type: 'Page_Bounce_Rate',
      },
    ],
  },
  page_average_time_on_page: {
    filterKey: 'page_average_time_on_page',
    title: 'Average Time on Page',
    options: [
      {
        text: 'Short',
        value: 'Short',
        type: 'Page_Average_Time_on_Page',
      },
      {
        text: 'Moderate',
        value: 'Moderate',
        type: 'Page_Average_Time_on_Page',
      },
      {
        text: 'Long',
        value: 'Long',
        type: 'Page_Average_Time_on_Page',
      },
    ],
  },
  page_conversion_rate: {
    filterKey: 'page_conversion_rate',
    title: 'Conversion Rate',
    options: [
      {
        text: 'Low',
        value: 'Low',
        type: 'Page_Conversion_Rate',
      },
      {
        text: 'Medium',
        value: 'Medium',
        type: 'Page_Conversion_Rate',
      },
      {
        text: 'High',
        value: 'High',
        type: 'Page_Conversion_Rate',
      },
    ],
  },
  page_scroll_depth: {
    filterKey: 'page_scroll_depth',
    title: 'Scroll Depth',
    options: [
      {
        text: 'Shallow',
        value: 'Shallow',
        type: 'Page_Scroll_Depth',
      },
      {
        text: 'Deep',
        value: 'Deep',
        type: 'Page_Scroll_Depth',
      },
    ],
  },
  page_engagement_actions: {
    filterKey: 'page_engagement_actions',
    title: 'Engagement Actions',
    options: [
      {
        text: 'Clicked CTA',
        value: 'Clicked CTA',
        type: 'Page_Engagement_Actions',
      },
      {
        text: 'Watched Video',
        value: 'Watched Video',
        type: 'Page_Engagement_Actions',
      },
      {
        text: 'Downloaded Content',
        value: 'Downloaded Content',
        type: 'Page_Engagement_Actions',
      },
    ],
  },
  page_return_visits: {
    filterKey: 'page_return_visits',
    title: 'Return Visits',
    options: [
      {
        text: 'None',
        value: 'None',
        type: 'Page_Return_Visits',
      },
      {
        text: 'Some',
        value: 'Some',
        type: 'Page_Return_Visits',
      },
      {
        text: 'Frequent',
        value: 'Frequent',
        type: 'Page_Return_Visits',
      },
    ],
  },
  page_interaction_events: {
    filterKey: 'page_interaction_events',
    title: 'Interaction Events',
    options: [
      {
        text: 'Comments',
        value: 'Comments',
        type: 'Page_Interaction_Events',
      },
      {
        text: 'Shares',
        value: 'Shares',
        type: 'Page_Interaction_Events',
      },
      {
        text: 'Likes',
        value: 'Likes',
        type: 'Page_Interaction_Events',
      },
    ],
  },
  page_content_freshness: {
    filterKey: 'page_content_freshness',
    title: 'Content Freshness',
    options: [
      {
        text: 'Fresh',
        value: 'Fresh',
        type: 'Page_Content_Freshness',
      },
      {
        text: 'Recent',
        value: 'Recent',
        type: 'Page_Content_Freshness',
      },
      {
        text: 'Stale',
        value: 'Stale',
        type: 'Page_Content_Freshness',
      },
    ],
  },
  page_seasonality: {
    filterKey: 'page_seasonality',
    title: 'Seasonality',
    options: [
      {
        text: 'Spring',
        value: 'Spring',
        type: 'Page_Seasonality',
      },
      {
        text: 'Summer',
        value: 'Summer',
        type: 'Page_Seasonality',
      },
      {
        text: 'Fall',
        value: 'Fall',
        type: 'Page_Seasonality',
      },
      {
        text: 'Winter',
        value: 'Winter',
        type: 'Page_Seasonality',
      },
      {
        text: 'Holiday Season',
        value: 'Holiday Season',
        type: 'Page_Seasonality',
      },
    ],
  },
  page_time_since_last_update: {
    filterKey: 'page_time_since_last_update',
    title: 'Time Since Last Update',
    options: [
      {
        text: 'Recent',
        value: 'Recent',
        type: 'Page_Time_Since_Last_Update',
      },
      {
        text: 'Moderate',
        value: 'Moderate',
        type: 'Page_Time_Since_Last_Update',
      },
      {
        text: 'Long',
        value: 'Long',
        type: 'Page_Time_Since_Last_Update',
      },
    ],
  },
  page_event_timing: {
    filterKey: 'page_event_timing',
    title: 'Event Timing',
    options: [
      {
        text: 'Upcoming',
        value: 'Upcoming',
        type: 'Page_Event_Timing',
      },
      {
        text: 'Ongoing',
        value: 'Ongoing',
        type: 'Page_Event_Timing',
      },
      {
        text: 'Past',
        value: 'Past',
        type: 'Page_Event_Timing',
      },
    ],
  },
  page_users_local_time: {
    filterKey: 'page_users_local_time',
    title: "User's Local Time",
    options: [
      {
        text: 'Morning',
        value: 'Morning',
        type: 'Page_Users_Local_Time',
      },
      {
        text: 'Afternoon',
        value: 'Afternoon',
        type: 'Page_Users_Local_Time',
      },
      {
        text: 'Evening',
        value: 'Evening',
        type: 'Page_Users_Local_Time',
      },
    ],
  },
  page_offer_expiry: {
    filterKey: 'page_offer_expiry',
    title: 'Offer Expiry',
    options: [
      {
        text: 'Expiring Soon',
        value: 'Expiring Soon',
        type: 'Page_Offer_Expiry',
      },
      {
        text: 'Valid',
        value: 'Valid',
        type: 'Page_Offer_Expiry',
      },
      {
        text: 'Expired',
        value: 'Expired',
        type: 'Page_Offer_Expiry',
      },
    ],
  },
  page_content_lifecycle_stage: {
    filterKey: 'page_content_lifecycle_stage',
    title: 'Content Lifecycle Stage',
    options: [
      {
        text: 'Launch Phase',
        value: 'Launch Phase',
        type: 'Page_Content_Lifecycle_Stage',
      },
      {
        text: 'Growth Phase',
        value: 'Growth Phase',
        type: 'Page_Content_Lifecycle_Stage',
      },
      {
        text: 'Maturity Phase',
        value: 'Maturity Phase',
        type: 'Page_Content_Lifecycle_Stage',
      },
      {
        text: 'Decline Phase',
        value: 'Decline Phase',
        type: 'Page_Content_Lifecycle_Stage',
      },
    ],
  },
  page_page_speed_score: {
    filterKey: 'page_page_speed_score',
    title: 'Page Speed Score',
    options: [
      {
        text: 'Good',
        value: 'Good',
        type: 'Page_Page_Speed_Score',
      },
      {
        text: 'Needs Improvement',
        value: 'Needs Improvement',
        type: 'Page_Page_Speed_Score',
      },
      {
        text: 'Poor',
        value: 'Poor',
        type: 'Page_Page_Speed_Score',
      },
    ],
  },
  page_mobile_usability_issues: {
    filterKey: 'page_mobile_usability_issues',
    title: 'Mobile Usability Issues',
    options: [
      {
        text: 'None',
        value: 'None',
        type: 'Page_Mobile_Usability_Issues',
      },
      {
        text: 'Minor',
        value: 'Minor',
        type: 'Page_Mobile_Usability_Issues',
      },
      {
        text: 'Major',
        value: 'Major',
        type: 'Page_Mobile_Usability_Issues',
      },
    ],
  },
  page_largest_contentful_paint_lcp: {
    filterKey: 'page_largest_contentful_paint_lcp',
    title: 'Largest Contentful Paint (LCP)',
    options: [
      {
        text: 'Fast',
        value: 'Fast',
        type: 'Page_Largest_Contentful_Paint_LCP',
      },
      {
        text: 'Moderate',
        value: 'Moderate',
        type: 'Page_Largest_Contentful_Paint_LCP',
      },
      {
        text: 'Slow',
        value: 'Slow',
        type: 'Page_Largest_Contentful_Paint_LCP',
      },
    ],
  },
  page_first_input_delay_fid: {
    filterKey: 'page_first_input_delay_fid',
    title: 'First Input Delay (FID)',
    options: [
      {
        text: 'Good',
        value: 'Good',
        type: 'Page_First_Input_Delay_FID',
      },
      {
        text: 'Needs Improvement',
        value: 'Needs Improvement',
        type: 'Page_First_Input_Delay_FID',
      },
      {
        text: 'Poor',
        value: 'Poor',
        type: 'Page_First_Input_Delay_FID',
      },
    ],
  },
  page_cumulative_layout_shift_cls: {
    filterKey: 'page_cumulative_layout_shift_cls',
    title: 'Cumulative Layout Shift (CLS)',
    options: [
      {
        text: 'Good',
        value: 'Good',
        type: 'Page_Cumulative_Layout_Shift_CLS',
      },
      {
        text: 'Needs Improvement',
        value: 'Needs Improvement',
        type: 'Page_Cumulative_Layout_Shift_CLS',
      },
      {
        text: 'Poor',
        value: 'Poor',
        type: 'Page_Cumulative_Layout_Shift_CLS',
      },
    ],
  },
  page_structured_data_errors: {
    filterKey: 'page_structured_data_errors',
    title: 'Structured Data Errors',
    options: [
      {
        text: 'None',
        value: 'None',
        type: 'Page_Structured_Data_Errors',
      },
      {
        text: 'Some Errors',
        value: 'Some Errors',
        type: 'Page_Structured_Data_Errors',
      },
      {
        text: 'Many Errors',
        value: 'Many Errors',
        type: 'Page_Structured_Data_Errors',
      },
    ],
  },
  page_indexing_issues: {
    filterKey: 'page_indexing_issues',
    title: 'Indexing Issues',
    options: [
      {
        text: 'Indexed',
        value: 'Indexed',
        type: 'Page_Indexing_Issues',
      },
      {
        text: 'Crawl Errors',
        value: 'Crawl Errors',
        type: 'Page_Indexing_Issues',
      },
      {
        text: 'Duplicate Content',
        value: 'Duplicate Content',
        type: 'Page_Indexing_Issues',
      },
    ],
  },
  page_robots_txt_compliance: {
    filterKey: 'page_robots_txt_compliance',
    title: 'Robots.txt Compliance',
    options: [
      {
        text: 'Allowed',
        value: 'Allowed',
        type: 'Page_Robots_txt_Compliance',
      },
      {
        text: 'Disallowed',
        value: 'Disallowed',
        type: 'Page_Robots_txt_Compliance',
      },
    ],
  },
  page_sitemap_presence: {
    filterKey: 'page_sitemap_presence',
    title: 'Sitemap Presence',
    options: [
      {
        text: 'Present',
        value: 'Present',
        type: 'Page_Sitemap_Presence',
      },
      {
        text: 'Missing',
        value: 'Missing',
        type: 'Page_Sitemap_Presence',
      },
    ],
  },
  page_security_issues: {
    filterKey: 'page_security_issues',
    title: 'Security Issues',
    options: [
      {
        text: 'None',
        value: 'None',
        type: 'Page_Security_Issues',
      },
      {
        text: 'Malware Detected',
        value: 'Malware Detected',
        type: 'Page_Security_Issues',
      },
      {
        text: 'Phishing Detected',
        value: 'Phishing Detected',
        type: 'Page_Security_Issues',
      },
    ],
  },
  page_open_graph_metadata: {
    filterKey: 'page_open_graph_metadata',
    title: 'Open Graph Metadata',
    options: [
      {
        text: 'Complete',
        value: 'Complete',
        type: 'Page_Open_Graph_Metadata',
      },
      {
        text: 'Partial',
        value: 'Partial',
        type: 'Page_Open_Graph_Metadata',
      },
      {
        text: 'Missing',
        value: 'Missing',
        type: 'Page_Open_Graph_Metadata',
      },
    ],
  },
  page_twitter_card_metadata: {
    filterKey: 'page_twitter_card_metadata',
    title: 'Twitter Card Metadata',
    options: [
      {
        text: 'Complete',
        value: 'Complete',
        type: 'Page_Twitter_Card_Metadata',
      },
      {
        text: 'Partial',
        value: 'Partial',
        type: 'Page_Twitter_Card_Metadata',
      },
      {
        text: 'Missing',
        value: 'Missing',
        type: 'Page_Twitter_Card_Metadata',
      },
    ],
  },
  page_social_shares: {
    filterKey: 'page_social_shares',
    title: 'Social Shares',
    options: [
      {
        text: 'Low',
        value: 'Low',
        type: 'Page_Social_Shares',
      },
      {
        text: 'Medium',
        value: 'Medium',
        type: 'Page_Social_Shares',
      },
      {
        text: 'High',
        value: 'High',
        type: 'Page_Social_Shares',
      },
    ],
  },
  page_comments_reactions: {
    filterKey: 'page_comments_reactions',
    title: 'Comments/Reactions',
    options: [
      {
        text: 'Few',
        value: 'Few',
        type: 'Page_Comments_Reactions',
      },
      {
        text: 'Some',
        value: 'Some',
        type: 'Page_Comments_Reactions',
      },
      {
        text: 'Many',
        value: 'Many',
        type: 'Page_Comments_Reactions',
      },
    ],
  },
  page_influencer_engagement: {
    filterKey: 'page_influencer_engagement',
    title: 'Influencer Engagement',
    options: [
      {
        text: 'Yes',
        value: 'Yes',
        type: 'Page_Influencer_Engagement',
      },
      {
        text: 'No',
        value: 'No',
        type: 'Page_Influencer_Engagement',
      },
    ],
  },
  page_hashtag_usage: {
    filterKey: 'page_hashtag_usage',
    title: 'Hashtag Usage',
    options: [
      {
        text: 'Branded Hashtags',
        value: 'Branded Hashtags',
        type: 'Page_Hashtag_Usage',
      },
      {
        text: 'Trending Hashtags',
        value: 'Trending Hashtags',
        type: 'Page_Hashtag_Usage',
      },
      {
        text: 'None',
        value: 'None',
        type: 'Page_Hashtag_Usage',
      },
    ],
  },
  page_user_generated_content: {
    filterKey: 'page_user_generated_content',
    title: 'User-Generated Content',
    options: [
      {
        text: 'Present',
        value: 'Present',
        type: 'Page_User_Generated_Content',
      },
      {
        text: 'Absent',
        value: 'Absent',
        type: 'Page_User_Generated_Content',
      },
    ],
  },
  page_social_platform_presence: {
    filterKey: 'page_social_platform_presence',
    title: 'Social Platform Presence',
    options: [
      {
        text: 'Facebook',
        value: 'Facebook',
        type: 'Page_Social_Platform_Presence',
      },
      {
        text: 'Twitter',
        value: 'Twitter',
        type: 'Page_Social_Platform_Presence',
      },
      {
        text: 'LinkedIn',
        value: 'LinkedIn',
        type: 'Page_Social_Platform_Presence',
      },
      {
        text: 'Instagram',
        value: 'Instagram',
        type: 'Page_Social_Platform_Presence',
      },
      {
        text: 'TikTok',
        value: 'TikTok',
        type: 'Page_Social_Platform_Presence',
      },
    ],
  },
};

export const ADVANCED_FILTER_OPTIONS_GOALS = [{ text: 'Is Equal to', value: '{value}' }];

export const SAVED_FILTER_OPTIONS = [{ text: 'Shared Segments', value: 'Shared Segments' }];

export const SAVED_SEGMENT_OPTIONS = [{ text: 'Shared Comparisons', value: 'Shared Comparisons' }];

export const SEGMENT_FILTER_CATEGORIES = {
  category: 'category_segment',
  subcategory1: 'category_subcategory1_concat_segment',
  subcategory2: 'category_subcat1_subcat2_concat_segment',
};

export const SEGMENT_FILTER_META = {
  // TODO populate this from api
  domain: {
    title: 'Domain Name',
    options: [{ text: 'none', value: 'none' }],
    key: 'domain_segment',
  },
  device: {
    title: 'Device',
    options: [
      { text: 'Desktop', value: 'DESKTOP', type: 'device' },
      { text: 'Mobile', value: 'MOBILE', type: 'device' },
      { text: 'Tablet', value: 'TABLET', type: 'device' },
    ],
    key: 'device_segment',
  },
  intent: {
    title: 'Intent',
    options: [{ text: 'none', value: 'none' }],
    key: 'intent_segment',
  },
  keyword_serp_features: {
    title: 'Keyword SERP Features',
    filterKey: 'keyword_serp_features',
    options: [
      {
        text: 'AI Overviews',
        value: 'AI Overviews',
        type: 'keyword_serp_features',
      },
      {
        text: 'Featured Snippet',
        value: 'Featured Snippet',
        type: 'keyword_serp_features',
      },
    ],
    key: 'keyword_serp_features',
  },
  country: {
    title: 'Country',
    options: [{ text: 'none', value: 'none' }],
    key: 'country_segment',
  },
  category: {
    title: 'Category',
    options: [{ text: 'none', value: 'none' }],
    key: 'category_segment',
  },
  sources: {
    title: 'Traffic Sources',
    options: [{ text: 'none', value: 'none' }],
    key: 'source_medium_selected',
  },
  pages: {
    title: 'Pages',
    options: [],
    key: 'page_segment',
  },
  createdby: {
    title: 'Created by',
    options: [],
    key: 'createdby_segment',
  },
  queries: {
    title: 'Queries',
    options: [],
    key: 'keyword_segment',
  },
  distinct_search_type: {
    title: 'Search Type',
    options: [{ text: 'none', value: 'none' }],
    key: 'search_type_segment',
  },
  goals_concat: {
    title: 'Goals',
    options: [{ text: 'none', value: 'none' }],
    key: 'goals_concat',
  },
  saved_segment: {
    title: 'Saved Segment',
    options: [],
    key: 'saved_segment',
  },
  saved_comparison: {
    title: 'Saved Comparison',
    options: [],
    key: 'saved_comparison',
  },
  is_branded: {
    title: 'Brand / Non-Brand',
    key: 'is_branded',
    options: [
      {
        text: 'All Searches',
        value: null,
        defaultApplied: true,
        type: 'branded',
      },
      { text: 'Branded', value: 'Yes', defaultApplied: false, type: 'branded' },
      {
        text: 'Non-Branded',
        value: 'No',
        defaultApplied: false,
        type: 'branded',
      },
    ],
  },
  page_list_segment: {
    title: 'Pages File',
    options: [],
    key: 'page_list_segment',
  },
  keyword_list_segment: {
    title: 'Queries File',
    options: [],
    key: 'keyword_list_segment',
  },
  audit_type: {
    title: 'Audit Type',
    options: [],
    key: 'audit_type',
  },
  keyword_city: {
    filterKey: 'keyword_city',
    title: 'Keyword City Tag',
    options: [],
    key: 'keyword_city_segment',
  },
  keyword_state: {
    filterKey: 'keyword_state',
    title: 'Keyword State Tag',
    options: [],
    key: 'keyword_state_segment',
  },
  keyword_country: {
    filterKey: 'keyword_country',
    title: 'Keyword Country Tag',
    options: [],
    key: 'keyword_country_segment',
  },
  page_city: {
    filterKey: 'page_city',
    title: 'Page City Tag',
    options: [],
    key: 'page_city_segment',
  },
  page_state: {
    filterKey: 'page_state',
    title: 'Page State Tag',
    options: [],
    key: 'page_state_segment',
  },
  page_country: {
    filterKey: 'page_country',
    title: 'Page Country Tag',
    options: [],
    key: 'page_country_segment',
  },
  page_experience: {
    title: 'Page Experience',
    key: 'page_experience',
    options: [
      {
        text: 'All',
        value: '',
        defaultApplied: true,
        type: 'page_experience',
      },
      {
        text: 'Poor',
        value: 'Slow',
        defaultApplied: false,
        type: 'page_experience',
      },
      {
        text: 'Needs Improvement',
        value: 'Medium',
        defaultApplied: false,
        type: 'page_experience',
      },
      {
        text: 'Good',
        value: 'Fast',
        defaultApplied: false,
        type: 'page_experience',
      },
    ],
  },
  performance_metrics: {
    title: 'Performance Metrics',
    filterKey: 'performance_metrics',
    key: 'performance_metrics',
    options: [
      {
        text: 'All',
        value: '',
        defaultApplied: true,
        type: 'performance_metrics',
      },
      {
        text: 'First Contentful Paint',
        value: 'FCP',
        defaultApplied: false,
        type: 'performance_metrics',
      },
      // {  //No relevant audits associated with SI & TTI
      //   text: "Speed Index",
      //   value: "SI",
      //   defaultApplied: false,
      //   type: "performance_metrics",
      // },
      {
        text: 'Largest Contentful Paint',
        value: 'LCP',
        defaultApplied: false,
        type: 'performance_metrics',
      },
      // {
      //   text: "Time to Interactive",
      //   value: "TTI",
      //   defaultApplied: false,
      //   type: "performance_metrics",
      // },
      {
        text: 'Total Blocking Time',
        value: 'TBT',
        defaultApplied: false,
        type: 'performance_metrics',
      },
      {
        text: 'Cumulative Layout Shift',
        value: 'CLS',
        defaultApplied: false,
        type: 'performance_metrics',
      },
      {
        text: 'Interaction to Next Paint',
        value: 'INP',
        defaultApplied: false,
        type: 'performance_metrics',
      },
    ],
  },
  language: {
    title: 'Language',
    options: [{ text: 'none', value: 'none' }],
    key: 'query_language_segment',
  },
  adgroup_name: {
    title: 'AdGroup Name',
    options: [{ text: 'none', value: 'none' }],
    key: 'adgroup_name_segment',
  },
  campaign_name: {
    title: 'Campaign Name',
    options: [{ text: 'none', value: 'none' }],
    key: 'campaign_name_segment',
  },
  campaign_type: {
    title: 'Campaign Type',
    options: [{ text: 'none', value: 'none' }],
    key: 'campaign_type_segment',
  },
  campaign_keyword: {
    title: 'Campaign Keywords',
    options: [],
    key: 'campaign_keyword_segment',
  },
  market_share_segment: {
    title: 'Market Segment',
    options: [{ text: 'none', value: 'none' }],
    key: 'market_share_segment',
  },
  rank_bucket_segment: {
    title: 'Rank Bucket',
    options: [{ text: 'none', value: 'none' }],
    key: 'rank_bucket_segment',
  },
  page: {
    title: 'Page',
    options: [],
    key: 'page',
  },
  Page: {
    title: 'Page',
    options: [],
    key: 'page',
  },
};

export const CUSTOM_RANGE = {
  label: 'Custom',
  value: 'custom',
  startDate: subDays(new Date(), 7),
  endDate: new Date(),
};

export const DATE_RANGE_META = [
  { ...CUSTOM_RANGE },
  ...[7, 30, 60, 90, 180].map((i) => {
    return {
      groupBy: 'Days',
      label: `Last ${i} Days`,
      value: `${i} days`,
      startDate: subDays(new Date(), i),
      endDate: subDays(new Date(), 1),
    };
  }),
  {
    groupBy: 'Complete Weeks',
    label: `Last Complete Week`,
    value: `1 weeks ago for 1 weeks`,
    startDate: subWeeks(startOfWeek(new Date()), 1),
    endDate: subDays(startOfWeek(new Date()), 1),
  },
  ...[2, 4, 8, 12, 26, 52].map((i) => {
    return {
      groupBy: 'Complete Weeks',
      label: `Last ${i} Complete Weeks`,
      value: `${i} weeks ago for ${i} weeks`,
      startDate: subWeeks(startOfWeek(new Date()), i),
      endDate: subDays(startOfWeek(new Date()), 1),
    };
  }),
  ...[4, 8, 12, 26].map((i) => {
    return {
      groupBy: 'Weeks',
      label: `Last ${i} Weeks`,
      value: `${i} weeks`,
      startDate: subWeeks(new Date(), i),
    };
  }),
  {
    groupBy: 'Months',
    label: 'Current Month',
    value: 'current month',
    startDate: startOfMonth(new Date()),
  },
  {
    groupBy: 'Months',
    label: 'Last Complete Month',
    value: 'last month',
    startDate: startOfMonth(subMonths(new Date(), 1)),
    endDate: endOfMonth(subMonths(new Date(), 1)),
  },
  {
    groupBy: 'Months',
    label: 'Last 3 Complete Months',
    value: 'last three months',
    startDate: startOfMonth(subMonths(new Date(), 3)),
    endDate: endOfMonth(subMonths(new Date(), 1)),
  },
  {
    groupBy: 'Months',
    label: 'Last 6 Complete Months',
    value: 'last six months',
    startDate: startOfMonth(subMonths(new Date(), 6)),
    endDate: endOfMonth(subMonths(new Date(), 1)),
  },

  {
    groupBy: 'Quarter',
    label: 'Current Quarter',
    value: 'current quarter',
    startDate: startOfQuarter(new Date()),
  },
  {
    groupBy: 'Quarter',
    label: 'Last Quarter',
    value: 'last quarter',
    startDate: startOfQuarter(subQuarters(new Date(), 1)),
    endDate: endOfQuarter(subQuarters(new Date(), 1)),
  },
  {
    groupBy: 'Quarter',
    label: 'Last Four Quarters',
    value: 'last four quarter',
    startDate: subQuarters(new Date(), 4),
  },

  {
    groupBy: 'Year',
    label: 'YTD',
    value: 'current year',
    startDate: startOfYear(new Date()),
  },
  {
    groupBy: 'Year',
    label: 'Last Year',
    value: 'last year',
    startDate: startOfYear(subYears(new Date(), 1)),
    endDate: endOfYear(subYears(new Date(), 1)),
  },
  {
    groupBy: 'Year',
    label: 'Current & Last Year',
    value: 'current & last year',
    startDate: addDays(endOfWeek(startOfYear(subYears(new Date(), 1))), 1),
    endDate: subDays(startOfWeek(new Date()), 1),
  },
];

export const TOP_N_VALUE = '10';

//  `top ${TOP_N_VALUE}`

export const DRILLDOWN_TABLE_HEADER = [
  'dates',
  'intent',
  'category',
  'pages',
  'queries',
  'campaign_keyword',
  'rank buckets',
  'language',
  'sources',
  'domain',
  'countries',
  'devices',
  `top ${TOP_N_VALUE}`,
];

export const TOP_N_ENTRIES = [
  {
    viewName: 'top_category',
    columnName: ['top_category'],
    displayText: `Top ${TOP_N_VALUE} Categories`,
  },
  {
    viewName: 'top_intent',
    columnName: ['top_intent'],
    displayText: `Top ${TOP_N_VALUE} Intents`,
  },
  {
    viewName: 'top_pages',
    columnName: ['top_pages'],
    displayText: `Top ${TOP_N_VALUE} Pages`,
  },
  {
    viewName: 'top_query',
    columnName: ['top_queries'],
    displayText: `Top ${TOP_N_VALUE} Queries`,
  },
  {
    viewName: 'top_subcategory',
    columnName: ['top_subcategory'],
    displayText: `Top ${TOP_N_VALUE} Subcategories`,
  },
  {
    viewName: 'top_category_intent',
    columnName: ['top_category_intent'],
    displayText: `Top ${TOP_N_VALUE} Category - Intent Combinations`,
  },
  {
    viewName: 'top_intent_subcategory',
    columnName: ['top_intent_subcategory'],
    displayText: `Top ${TOP_N_VALUE} Intent - Sub-Category 1`,
  },
  {
    viewName: 'top_category_subcategory',
    columnName: ['top_category_subcategory'],
    displayText: `Top ${TOP_N_VALUE} Category - Subcategory1 Combinations`,
  },
  {
    viewName: 'top_countries',
    columnName: ['top_countries'],
    displayText: `Top ${TOP_N_VALUE} Countries`,
  },
];

export const BREAKDOWN_BY_OPTIONS = {
  pages: [
    { text: 'Pages', value: 'pages' },
    { text: 'Group By Page City Tags', value: 'page city tags' },
    { text: 'Group By Page Country Tags', value: 'page country tags' },
    { text: 'Group By Page State Tags', value: 'page state tags' },
  ],
  queries: [
    { text: 'Queries', value: 'queries' },
    { text: 'Group By Keyword City Tags', value: 'keyword city tags' },
    { text: 'Group By Keyword Country Tags', value: 'keyword country tags' },
    { text: 'Group By Keyword State Tags', value: 'keyword state tags' },
  ],
};

export const DRILL_OPTIONS = {
  dates: [
    { id: 'quarter', label: 'by Quarter' },
    { id: 'month', label: 'by Month' },
    { id: 'week', label: 'by Week' },
    { id: 'day', label: 'by Day' },
  ],
  common: [
    { id: 'pages', label: 'by Pages' },
    { id: 'queries', label: 'by Queries' },
    { id: 'category', label: 'by Category' },
    { id: 'subcategory1', label: 'by Sub-Category 1' },
    { id: 'subcategory2', label: 'by Sub-Category 2' },
    { id: 'rank buckets', label: 'by Rank Buckets' },
    { id: 'intent', label: 'by Intent' },
    { id: 'campaign_keyword', label: 'by Campaign Keywords' },
    { id: 'sources', label: 'by Traffic Sources' },
    { id: 'countries', label: 'by Countries' },
    { id: 'devices', label: 'by Devices' },
    { id: 'domain', label: 'by Domain' },
    {
      id: 'page tag',
      label: 'by Page Tags',
      listItems: [
        { id: 'page city tags', label: 'by Page City Tags' },
        { id: 'page state tags', label: 'by Page State Tags' },
        { id: 'page country tags', label: 'by Page Country Tags' },
      ],
    },
    {
      id: 'keyword tag',
      label: 'by Keyword Tags',
      listItems: [
        { id: 'keyword city tags', label: 'by Keyword City Tags' },
        { id: 'keyword state tags', label: 'by Keyword State Tags' },
        { id: 'keyword country tags', label: 'by Keyword Country Tags' },
      ],
    },
    { id: 'page_experience', label: 'by Page Experience' },
    { id: 'language', label: 'by Language' },
    { id: 'adgroup_name', label: 'by AdGroup Name' },
    { id: 'campaign_name', label: 'by Campaign Name' },
  ],
  siteSpeedCompetitve: [
    { id: 'category', label: 'by Category' },
    { id: 'subcategory1', label: 'by Sub-Category 1' },
    { id: 'subcategory2', label: 'by Sub-Category 2' },
    { id: 'devices', label: 'by Devices' },
    { id: 'domain', label: 'by Domain' },
    { id: 'pages', label: 'by Pages' },
  ],
};

export const DATES_GRANULARITY = ['day', 'week', 'month', 'quarter'];

export const SITE_POP_DRILL_OPTIONS = ['quarter', 'month', 'week', 'day', 'dates', 'domain', 'countries', 'devices'];

export const KEYWORD_POP_DRILL_OPTIONS = [
  'intent',
  'category',
  'language',
  'subcategory1',
  'subcategory2',
  'pages',
  'queries',
  `top ${TOP_N_VALUE}`,
  'page_experience',
  'adgroup_name',
  'campaign_name',
  'campaign_keyword',
  'keyword country tags',
  'keyword city tags',
  'keyword state tags',
  'page country tags',
  'page city tags',
  'page state tags',
];

export const NO_OF_RECORDS_PER_PAGE = 10;

export const TOP_COMPETITORS_N_VALUE = 10;

export const ROOT_CAUSE_OPTIONS = [
  { text: 'Software Regression', value: 'Software Regression' },
  { text: 'Technical SEO Issue', value: 'Technical SEO Issue' },
  { text: 'Content Issue', value: 'Content Issue' },
  { text: 'Infrastructure Issue', value: 'Infrastructure Issue' },
  { text: 'Performance', value: 'Performance' },
  { text: 'Competitor Move', value: 'Competitor Move' },
  { text: 'Google Algorithm Change', value: 'Google Algorithm Change' },
  { text: 'Seasonality', value: 'Seasonality' },
  { text: 'Normal Fluctuation', value: 'Normal Fluctuation' },
];

export const CUSTOMER_NAME = 'Our';

export const UPDATE_TREND_OPTIONS = [
  { text: 'Update Trend', value: 'updateTrend' },
  { text: 'Save as New Trend', value: 'saveAsNewTrend' },
  { text: 'Archive Trend', value: 'archiveTrend' },
];

export const EVENT_OPTIONS = [
  {
    text: 'Major Release for Opportunity',
    value: 'major-release-for-opportunity',
  },
  {
    text: 'Minor Release for Opportunity',
    value: 'minor-release-for-opportunity',
  },
  { text: 'Google Re-crawled Content', value: 'google-recrawled-content' },
];

export const NONE_METRIC = 'none';

export const DRILL_DOWN_FILTERS = {
  domain: 'domain_segment',
  devices: 'device_segment',
  intent: 'intent_segment',
  countries: 'country_segment',
  category: 'category_segment',
  sources: 'source_medium_selected',
  pages: 'page_segment',
  queries: 'keyword_segment',
  language: 'query_language_segment',
};

export const COMMON_DEFAULT_FILTERS = {
  search_type_segment: [{ text: 'web', value: 'web', filterType: 'Is Equal to', defaultApplied: true }],
  source_medium_selected: [
    {
      text: 'google/organic',
      value: 'google/organic',
      type: 'sources',
      defaultApplied: true,
      filterType: 'Is Equal to',
    },
  ],
  is_branded: [{ text: 'All Searches', value: null, defaultApplied: true, type: 'branded' }],
  page_experience: [{ text: 'All', value: '', defaultApplied: true, type: 'page_experience' }],
};

export const GSC_METRIC_GROUP = ['clicks', 'impressions', 'average^_ctr'];

export const GA_METRIC_GROUP = [
  'visitors',
  'conversions',
  'bounce^_rate',
  'average^_session^_duration',
  'TOTAL_SESSIONS',
  'unique^_page^_views',
  'average^_time^_on^_pagee',
  'total^_value',
  'total^_events',
  'conversion^_rate',
  'average^_events',
];

export const GA_METRIC_SUMMARY_GROUP = ['Conversion Summary', 'Visitors Summary'];

export const USABILITY_METRIC_GROUP = ['performance', 'AccessibilityScore', 'BestPracticesScore', 'SEOScore'];

export const PERFORMANCE_METRIC_GROUP = ['SIScore', 'FCPScore', 'CLSScore', 'TTIScore', 'TBTScore', 'LCPScore'];

export const RANKING_FACTORS_AUDIT_DRILL_OPTIONS = ['Accessibility', 'SEO Compliance', 'Best Practices'];
export const NO_OF_METRICS_AVAILABLE = 4;

export const LH_GRADE_VIEW_NAME = 'site_usability_lh_grade';

export const CITY_STATE = ['city', 'state'];

export const GEO_DIMENSION_EXPLORE = 'page_user_conversion_geo_dimensions';

export const PERCENTAGE_CHANGE_COLOR_KEY = '% Change';

export const MARKET_SHARE_COLOR_KEY = 'Market Share';

export const SUMMARY_REPORT_METRIC_OPTION = {
  text: 'Summary Reports',
  value: 'Summary Reports',
  subMenuItems: [
    {
      text: 'Search Engine Performance',
      value: 'Search Engine Performance',
      isGroupedMetric: true,
      metrics: [
        { text: 'Clicks', value: 'clicks' },
        { text: 'Impressions', value: 'impressions' },
        { text: 'CTR', value: 'average^_ctr' },
        { text: 'Position', value: 'average^_position' },
      ],
    },
    {
      text: 'Visitors Summary',
      value: 'Visitors Summary',
      isGroupedMetric: true,
      metrics: [
        { text: 'Visitors', value: 'visitors' },
        { text: 'Conversions', value: 'conversions' },
        { text: 'Bounce Rate', value: 'bounce^_rate' },
        { text: 'Average Session Duration', value: 'average^_session^_duration' },
      ],
    },
    {
      text: 'Conversion Summary',
      value: 'Conversion Summary',
      isGroupedMetric: true,
      metrics: [
        { text: 'Visitors', value: 'visitors' },
        { text: 'Conversions', value: 'conversions' },
        { text: 'Conversion Rate', value: 'conversion^_rate' },
        { text: 'Bounce Rate', value: 'bounce^_rate' },
      ],
    },
    {
      text: 'Site Speed Summary',
      value: 'Site Speed Summary',
      isGroupedMetric: true,
      metrics: [
        { text: 'Largest Contentful Paint (LCP)', value: 'LCPScore' },
        { text: 'Cumulative Layout Shift (CLS)', value: 'CLSScore' },
        { text: 'Interaction to Next Paint (INP)', value: 'INPScore' },
        { text: 'Clicks', value: 'clicks' },
      ],
    },
    {
      text: 'Site Usability Summary',
      value: 'Site Usability Summary',
      isGroupedMetric: true,
      metrics: [
        { text: 'Performance Score', value: 'performance' },
        { text: 'Best Practices Score', value: 'BestPracticesScore' },
        { text: 'SEO Compliance Score', value: 'SEOScore' },
        { text: 'Clicks', value: 'clicks' },
      ],
    },
    {
      text: 'Google Ads Summary',
      value: 'Google Ads Summary',
      isGroupedMetric: true,
      metrics: [
        { text: 'Clicks', value: 'clicks' },
        { text: 'Conversions', value: 'conversions' },
        { text: 'Total Cost', value: 'cost' },
        { text: 'Cost Per Conversions', value: 'cost^_per^_conversion' },
      ],
    },
  ],
};

export const SITE_USABILITY_METRICS_ARRAY = [
  { text: 'Performance Score', value: 'performance' },
  { text: 'Best Practices Score', value: 'BestPracticesScore' },
  { text: 'SEO Compliance Score', value: 'SEOScore' },
  { text: 'Accessibility Score', value: 'AccessibilityScore' },
];

export const MARKET_SHARE_METRIC_OPTION = { text: 'Market Share', value: 'market^_share' };

export const FEATURED_SNIPPET_METRIC = {
  text: 'Featured Snippets',
  value: 'total_count_of_feature_snippet_owner',
};

export const AVERAGE_AI_OVERVIEW_METRIC = {
  text: 'AI Overviews',
  value: 'avg_ai_overviews',
};

// client only - right side metric
export const COUNT_OF_SERPS_WITH_AI_OVERVIEWS = {
  text: 'Daily Count of SERPs with AI Overviews',
  value: 'avg_daily_count_of_serps_with_ai_overview',
};
// client only - right side metric
export const PERCENTAGE_OF_SERPS_WITH_AI_OVERVIEWS = {
  text: '% of SERPs with AI Overviews',
  value: 'avg_percentage_of_serps_with_ai_overview',
};

export const PERCENTAGE_INCLUSION_IN_AI_OVERVIEWS = {
  text: '% Inclusion in AI Overviews',
  value: 'percentage_inclusion_in_ai_overviews',
};

export const PAGE_IMPRESSIONS_IN_AI_OVERVIEWS = {
  text: 'Daily Page Count in AI Overviews',
  value: 'page_impressions_in_ai_overviews',
};

export const AVERAGE_DAILY_VISIBILITY_IN_AI_OVERVIEWS = {
  text: 'Daily Visibility in AI Overviews',
  value: 'average_daily_visibility_in_ai_overviews',
};

export const AI_OVERVIEW_METRIC_OPTIONS_1 = {
  text: 'AI Overviews',
  value: 'avg_ai_overviews',
  subMenuItems: [
    PAGE_IMPRESSIONS_IN_AI_OVERVIEWS,
    AVERAGE_DAILY_VISIBILITY_IN_AI_OVERVIEWS,
    PERCENTAGE_INCLUSION_IN_AI_OVERVIEWS,
  ],
};

export const AI_OVERVIEW_METRIC_OPTIONS_2 = {
  text: 'AI Overviews',
  value: 'avg_ai_overviews',
  subMenuItems: [
    COUNT_OF_SERPS_WITH_AI_OVERVIEWS,
    // PERCENTAGE_OF_SERPS_WITH_AI_OVERVIEWS
  ],
};

// Brand/Sentiment metrics
export const TOTAL_MENTIONS_METRIC = { text: 'Total Mentions', value: 'sum_total_mentions' };
export const TOTAL_POSITIVE_MENTIONS_METRIC = {
  text: 'Total Positive Mentions',
  value: 'sum_positive_mentions',
};
export const TOTAL_NEGATIVE_MENTIONS_METRIC = {
  text: 'Total Negative Mentions',
  value: 'sum_negative_mentions',
};
export const TOTAL_NEUTRAL_MENTIONS_METRIC = {
  text: 'Total Neutral Mentions',
  value: 'sum_neutral_mentions',
};

export const POSITIVE_SENTIMENT_PERCENTAGE_METRIC = {
  text: '% Positive Sentiment',
  value: 'positive_sentiment_percentage',
};
export const NEGATIVE_SENTIMENT_PERCENTAGE_METRIC = {
  text: '% Negative Sentiment',
  value: 'negative_sentiment_percentage',
};
export const NEUTRAL_SENTIMENT_PERCENTAGE_METRIC = {
  text: '% Neutral Sentiment',
  value: 'neutral_sentiment_percentage',
};

export const BRAND_MENTIONS_METRICS_OPTIONS = {
  text: 'Brand Mentions',
  value: 'Brand Mentions',
  subMenuItems: [
    TOTAL_MENTIONS_METRIC,
    TOTAL_POSITIVE_MENTIONS_METRIC,
    TOTAL_NEGATIVE_MENTIONS_METRIC,
    TOTAL_NEUTRAL_MENTIONS_METRIC,
    POSITIVE_SENTIMENT_PERCENTAGE_METRIC,
    NEGATIVE_SENTIMENT_PERCENTAGE_METRIC,
    NEUTRAL_SENTIMENT_PERCENTAGE_METRIC,
  ],
};

// Deprecated group holder; keep constants above but do not surface another group entry
export const SENTIMENT_PERCENTAGE_METRIC_OPTIONS = {
  text: 'Sentiment Percentage Metrics',
  value: 'Sentiment Percentage Metrics',
  subMenuItems: [
    POSITIVE_SENTIMENT_PERCENTAGE_METRIC,
    NEGATIVE_SENTIMENT_PERCENTAGE_METRIC,
    NEUTRAL_SENTIMENT_PERCENTAGE_METRIC,
  ],
};

export const RANKED_KEYWORDS_METRIC = {
  text: 'Ranked Keywords',
  value: 'total_count_of_comp_ranked_keywords',
};

export const RANKED_PAGES_METRIC = {
  text: 'Ranked Pages',
  value: 'total_count_of_comp_ranked_pages',
};

export const AVERAGE_RANK_METRIC = { text: 'Average Rank', value: 'avg_rank' };

export const MARKET_SHARE_SUMMARY_OPTION = {
  text: 'Market Share Summary',
  value: 'Market Share Summary',
  isGroupedMetric: true,
  metrics: [
    MARKET_SHARE_METRIC_OPTION,
    { text: 'Clicks', value: 'clicks' },
    { text: 'Impressions', value: 'impressions' },
    { text: 'Position', value: 'average^_position' },
  ],
};

export const AVERAGE_RANK_SUMMARY_OPTION = {
  text: 'Average Rank Summary',
  value: 'Average Rank Summary',
  isGroupedMetric: true,
  metrics: [
    AVERAGE_RANK_METRIC,
    { text: 'Clicks', value: 'clicks' },
    { text: 'Impressions', value: 'impressions' },
    { text: 'Position', value: 'average^_position' },
  ],
};

export const SITE_SPEED_METRIC_OPTIONS = {
  text: 'Site Speed',
  value: 'Site Speed',
  subMenuItems: [
    {
      text: 'Usability Score',
      value: 'Usability Score',
      subMenuItems: [
        { text: 'Performance Score', value: 'performance' },
        { text: 'Accessibility Score', value: 'AccessibilityScore' },
        { text: 'Best Practices Score', value: 'BestPracticesScore' },
        { text: 'SEO Compliance Score', value: 'SEOScore' },
      ],
    },
    {
      text: 'Performance Metrics',
      value: 'Performance Metrics',
      subMenuItems: [
        { text: 'Speed Index', value: 'SIScore' },
        { text: 'First Contentful Paint (FCP)', value: 'FCPScore' },
        { text: 'Cumulative Layout Shift (CLS)', value: 'CLSScore' },
        { text: 'Time to Interactive (TTI)', value: 'TTIScore' },
        { text: 'Total Blocking Time (TBT)', value: 'TBTScore' },
        { text: 'Largest Contentful Paint (LCP)', value: 'LCPScore' },
        { text: 'Interaction to Next Paint (INP)', value: 'INPScore' },
      ],
    },
  ],
};

export const SITE_SPEED_METRIC_VALUES = [
  'performance',
  'AccessibilityScore',
  'BestPracticesScore',
  'SEOScore',
  'SIScore',
  'FCPScore',
  'CLSScore',
  'TTIScore',
  'INPScore',
  'TBTScore',
  'LCPScore',
];

export const COMPETITIVE_TRENDS_METRIC_1_LIST = [
  MARKET_SHARE_METRIC_OPTION,
  FEATURED_SNIPPET_METRIC,
  AI_OVERVIEW_METRIC_OPTIONS_1,
  SITE_SPEED_METRIC_OPTIONS,
  BRAND_MENTIONS_METRICS_OPTIONS,
  RANKED_KEYWORDS_METRIC,
  RANKED_PAGES_METRIC,
  AVERAGE_RANK_METRIC,
  AVERAGE_RANK_SUMMARY_OPTION,
  MARKET_SHARE_SUMMARY_OPTION,
];

export const EXCEL_COMMON_FONT = 'Open Sans Regular';

export const CR_EXCEL_COMMON_META = {
  TOP_HEADER_COLOR: 'FF0A2975',
  SUB_HEADER_COLOR: 'FF225D98',
  DATA_ROW_COLOR: 'FFEFF1F6',
  DEFAULT_ROW_HEIGHT: 45,
  DATA_TABLE_START_INDEX: 16,
  TABLE_DATA_ROW_HEIGHT: 25,
  DEFAULT_COLUMN_WIDTH: 40,
  DATA_COLUMN_WIDTH: 65,
  TABLE_DATA_ROW_HEADER_HEIGHT: 20,
  SUMMARY_TABLE_ROW_HEIGHT: 55,
  SUMMARY_TABLE_HEADER_HEIGHT: 35,
};

const { SUB_HEADER_COLOR, DATA_ROW_COLOR, TOP_HEADER_COLOR } = CR_EXCEL_COMMON_META;

export const BORDER_PROPERTIES = {
  top: { style: 'thin' },
  left: { style: 'thin' },
  bottom: { style: 'thin' },
  right: { style: 'thin' },
};

export const SUB_HEADER_PROPERTIES = {
  font: { name: EXCEL_COMMON_FONT, family: 4, size: 12, bold: true, color: { argb: 'FFFFFFFF' } },
  fill: {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: SUB_HEADER_COLOR },
  },
  alignment: { vertical: 'middle', horizontal: 'center' },
};

export const DATA_ROW_PROPERTIES = {
  font: { name: EXCEL_COMMON_FONT, family: 4, size: 12, bold: false, color: { argb: 'FF000000' } },
  fill: {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: DATA_ROW_COLOR },
  },
  alignment: { vertical: 'middle', horizontal: 'left', wrapText: true, indent: 1 },
};

export const CONTENT_RECOMMENDATIONS_EXCEL_EXPORT_META = {
  top_header: {
    row: '1',
    id: {
      cell: 'A1',
      color: '',
      endCell: 'B1',
    },
    cust_url: {
      start_cell: 'A2',
      end_cell: 'J2',
      row: '2',
    },
    summary_title: {
      start_cell: 'C1',
      end_cell: 'J1',
      text: 'Recommendation Summary',
    },
    // summary_logo: {
    //   cell: 'F1',
    //   text: 'Quattr'
    // },
    formatting: {
      font: {
        name: EXCEL_COMMON_FONT,
        family: 4,
        size: 18,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: TOP_HEADER_COLOR },
      },
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  published_changes: {
    start_cell: 'A10',
    end_cell: 'F10',
    row: '8',
    header: {
      title: 'Page Revision History',
      columns: [
        { name: 'Recommendation ID', start_cell: 'A11', data_start_cell: 'A12', width: 45 },
        {
          name: 'Page Url',
          start_cell: 'B11',
          end_cell: 'D11',
          data_start_cell: 'B12',
          data_end_cell: 'D12',
          width: 45,
        },
        { name: 'Updated By', start_cell: 'E11', data_start_cell: 'E12', width: 45 },
        { name: 'Updated Date', start_cell: 'F11', data_start_cell: 'F12', width: 45 },
      ],
    },
  },

  implementation_note: {
    start_cell: 'A6',
    end_cell: 'F6',
    row: '8',
    header: {
      title: 'Implementation Note',
      columns: [
        { name: 'No', start_cell: 'A7', data_start_cell: 'A8', width: 45 },
        {
          name: 'Implementation Note',
          start_cell: 'B7',
          end_cell: 'D7',
          data_start_cell: 'B8',
          data_end_cell: 'D8',
          width: 45,
        },
        { name: 'Added By', start_cell: 'E7', data_start_cell: 'E8', width: 45 },
        { name: 'Date', start_cell: 'F7', data_start_cell: 'F8', width: 45 },
      ],
    },
  },
  summary_table: {
    cell: 'A3',
    row: '3',
    columns: [
      {
        name: 'Recommendation',
        id: 'col1',
      },
      {
        name: 'Current Relevance Score',
        id: 'col2',
      },
      {
        name: 'Projected Relevance Score',
        id: 'col3',
      },
      {
        name: 'Current Content Quality Score',
        id: 'col4',
      },
      {
        name: 'Projected Content Quality Score',
        id: 'col5',
      },
      {
        name: 'Monthly Clicks',
        id: 'col6',
      },
      {
        name: 'Monthly Impressions',
        id: 'col7',
      },
      {
        name: '',
        id: 'col8',
      },
      {
        name: '',
        id: 'col9',
      },
      {
        name: 'Status',
        id: 'col10',
      },
    ],
    formatting: {
      font: {
        name: EXCEL_COMMON_FONT,
        family: 4,
        size: 12,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: SUB_HEADER_COLOR },
      },
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  tab_data: {
    top_header: {
      start_cell: 'A14',
      end_cell: 'E14',
      title: 'Recommended Improvements',
    },
    meta: {
      table_header: {
        columns: [
          {
            name: 'Recommendation ID',
          },
          {
            name: 'Current Tag',
          },
          {
            name: 'Suggested Tag',
          },
          {
            name: 'Current Content',
          },
          {
            name: 'Suggested Content',
          },
        ],
      },
    },
    headings: {
      table_header: {
        columns: [
          {
            name: 'Recommendation ID',
          },
          {
            name: 'Current Tag',
          },
          {
            name: 'Suggested Tag',
          },
          {
            name: 'Current Content',
          },
          {
            name: 'Suggested Content',
          },
        ],
      },
    },
    links: {
      table_header: {
        columns: [
          {
            name: 'Recommendation ID',
          },
          {
            name: 'Current Tag',
          },
          {
            name: 'Suggested Tag',
          },
          {
            name: 'Current Content',
          },
          {
            name: 'Suggested Content',
          },
          {
            name: 'URL',
          },
          {
            name: 'Improvement Type',
          },
        ],
      },
    },
    images: {
      table_header: {
        columns: [
          {
            name: 'Recommendation ID',
          },
          {
            name: 'Current Tag',
          },
          {
            name: 'Suggested Tag',
          },
          {
            name: 'Current Content',
          },
          {
            name: 'Suggested Content',
          },
          {
            name: 'URL',
          },
        ],
      },
    },
    body: {
      table_header: {
        columns: [
          {
            name: 'Recommendation ID',
          },
          {
            name: 'Current Tag',
          },
          {
            name: 'Suggested Tag',
          },
          {
            name: 'Current Content',
          },
          {
            name: 'Suggested Content',
          },
        ],
      },
    },
    structured_data: {
      table_header: {
        columns: [
          {
            name: 'Recommendation ID',
          },
          {
            name: 'Structured Data',
          },
          {
            name: 'Markup Attribute',
          },
          {
            name: 'Suggested Content',
          },
        ],
      },
    },
    topics: {
      table_header: {
        columns: [
          {
            name: 'Rank',
          },
          {
            name: 'Topic Name',
          },
          {
            name: 'Topic Importance',
          },
          {
            name: 'Heading Tag',
          },
          {
            name: 'Heading Content',
          },
          {
            name: 'Body Tag',
          },
          {
            name: 'Body Content',
          },
          {
            name: 'Content State',
          },
        ],
      },
    },
  },
};

export const filterTypes = {
  device: { value: '{value}', children: 'Is Equal to' },
  intent: { value: '{value}', children: 'Is Equal to' },
  country: { value: '{value}', children: 'Is Equal to' },
  sources: { value: '{value}', children: 'Is Equal to' },
  category: { value: '{value}', children: 'Is Equal to' },
  pages: { value: '{value}', children: 'Is Equal to' },
  queries: { value: '{value}', children: 'Is Equal to' },
  distinct_search_type: { value: '{value}', children: 'Is Equal to' },
  goals_concat: { value: '{value}', children: 'Is Equal to' },
  domain: { value: '{value}', children: 'Is Equal to' },
  language: { value: '{value}', children: 'Is Equal to' },
  adgroup_name: { value: '{value}', children: 'Is Equal to' },
  campaign_name: { value: '{value}', children: 'Is Equal to' },
  campaign_type: { value: '{value}', children: 'Is Equal to' },
  page_experience: { value: '{value}', children: 'Is Equal to' },
  keyword_country: { value: '{value}', children: 'Is Equal to' },
  keyword_state: { value: '{value}', children: 'Is Equal to' },
  keyword_city: { value: '{value}', children: 'Is Equal to' },
  page_country: { value: '{value}', children: 'Is Equal to' },
  page_state: { value: '{value}', children: 'Is Equal to' },
  page_city: { value: '{value}', children: 'Is Equal to' },
  keyword_serp_features: { value: '%{value}%', children: 'Include' },
};

export const RANK_BUCKETS_FILTERS = [
  'Ranking 1 to 3',
  'Ranking 4 to 6',
  'Ranking 7 to 9',
  'Ranking 10 to 20',
  'Ranking 20 to 40',
  'Ranking 40+',
];

export const EXTRACT_SEGMENT_FILTER_PARAMS = [
  'country_segment',
  'domain_segment',
  'device_segment',
  'intent_segment',
  'search_type_segment',
  'goals_concat',
  'keyword_segment',
  'page_segment',
  'source_medium_selected',
  'is_branded',
  'page_list_segment',
  'keyword_list_segment',
  'page_experience',
  'query_language_segment',
  'adgroup_name_segment',
  'campaign_name_segment',
  'campaign_type_segment',
  'campaign_keyword_segment',
  'market_share_segment',
  'rank_bucket_segment',
  'keyword_city_segment',
  'keyword_state_segment',
  'keyword_country_segment',
  'page_city_segment',
  'page_state_segment',
  'page_country_segment',
  'keyword_serp_features',
];

export const LINE_CHART_METRICS = [CTR];

export const INTERNAL_LINKING_FILTERS = {
  category: { label: 'Category', key: 'Category' },
  // trafficSources: { label: 'Traffic Sources', key: 'Traffic_Sources' }, //commented for now as per request
  pages: { label: 'Pages', key: 'Pages' },
  // country: { label: 'Country', key: 'Country' }, //commented for now as per request
  pageTags: { label: 'Page Tags', key: 'Page_Tags' },
  // pageCity:{label: 'PageCity', key: 'Page_City'},
  // pageState:{label: 'Page_State', key: 'Page_State'},
  // PageCountry:{label: 'Page Country',key: 'Page_Country'}
};

export const CONDITIONS_KEYS = {
  Is_Equal_to: [],
  Contains: [],
  Starts_With: [],
  Ends_With: [],
  Is_Not_Equal_to: [],
  "Doesn't_Contain": [],
  "Doesn't_Start_with": [],
};

export const DEFAULT_INTERNAL_LINKING_FILTERS_OBJ = {
  'Overall Metrics': {
    Source_Criteria: {
      src_criteria_id_draft: '',
      Internal_Linking_Url_Count: 0,
      Filters: {
        Category: CONDITIONS_KEYS,
        Traffic_Sources: CONDITIONS_KEYS,
        Pages: CONDITIONS_KEYS,
        Country: CONDITIONS_KEYS,
        Page_City: CONDITIONS_KEYS,
        Page_State: CONDITIONS_KEYS,
        Page_Country: CONDITIONS_KEYS,
      },
    },
    Target_Criteria: {
      target_criteria_id_draft: '',
      Internal_Linking_Url_Count: 0,
      Filters: {
        Category: CONDITIONS_KEYS,
        Traffic_Sources: CONDITIONS_KEYS,
        Pages: CONDITIONS_KEYS,
        Country: CONDITIONS_KEYS,
        Page_City: CONDITIONS_KEYS,
        Page_State: CONDITIONS_KEYS,
        Page_Country: CONDITIONS_KEYS,
      },
    },
  },
};
